<template>
  <section>
    <!-- <editar-permiso-detalle /> -->
    <crear-permiso-cargo-vacacion />
    <v-card>
      <v-card-text class="grey lighten-2 text--info">
        <v-layout wrap>
          <v-flex class="px-3">
            <v-btn
              icon
              color="primary"
              v-if="getRuta() == getPersonaId()"
              :to="`/permisos/usuario/${getPersonaId()}`"
            >
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <strong> Crear solicitud de nuevo permiso </strong>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-container grid-list-md class="p-0" style="min-width: 100%">
            <v-layout wrap row>
              <v-flex xs12>
                <v-autocomplete
                  class="text-field-reducido-border"
                  :items="tipo_permisos"
                  item-value="id"
                  item-text="descripcion"
                  v-model="form.id_tipo_permiso"
                  @change="
                    obtenerFechasIniciales(form.id_tipo_permiso) &&
                      verificarCompensacion(false) &&
                      obtenerSubpermiso(form.id_tipo_permiso) &&
                      verificaCenso(form.id_tipo_permiso)
                  "
                  label="Solicitar permiso"
                  maxlength="50"
                  :rules="$validate(['required'])"
                  outline
                  clearable
                  required
                />
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="form.id_tipo_permiso == 44">
              <v-flex xs12 md6>
                <v-select
                  class="text-field-reducido-border"
                  :items="tipo_subpermisos"
                  item-value="id"
                  item-text="descripcion"
                  name="id_tipo_subpermiso"
                  label="Condición o estado crítico de salud"
                  v-model="form.id_tipo_subpermiso"
                  autofocus
                  maxlength="200"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout rowwrap v-if="form.id_tipo_permiso == 90">
              <v-flex xs12 md6>
                <v-autocomplete
                  class="text-field-reducido-border"
                  :items="tipos_baja"
                  item-value="descripcion"
                  item-text="descripcion"
                  v-model="form.tipo_baja"
                  label="Tipo de baja"
                  maxlength="50"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
                <!-- :disabled="permiso_detalles.length > 0" -->
              </v-flex>
            </v-layout>

            <v-layout
              row
              wrap
              v-if="form.id_tipo_permiso == 87 || form.id_tipo_permiso == 103"
            >
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.lugar"
                  label="Lugar de comisión "
                  maxlength="50"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
            </v-layout>
            <!-- Causal de acuerdo al ART. 15 RM 1111:  - Permiso personal sin goce de haberes p18-->
            <v-layout wrap v-if="form.id_tipo_permiso == 18">
              <v-flex xs12 md6>
                <v-select
                  class="text-field-reducido-border"
                  :items="list_causal_permiso_sin_goce"
                  item-value="descripcion"
                  item-text="descripcion"
                  name="id_causal"
                  label="Causal de acuerdo al ART. 15 RM 1111:"
                  v-model="form.causal_sin_goce"
                  autofocus
                  maxlength="200"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
            <!-- Permiso dia de la madre p99 - Campo motivo-->
            <v-layout>
              <v-flex
                xs12
                md6
                v-if="
                  form.id_tipo_permiso == 87 ||
                    form.id_tipo_permiso == 96 ||
                    form.id_tipo_permiso == 103 ||
                    form.id_tipo_permiso == 105 ||
                    form.id_tipo_permiso == 101
                "
              >
                <v-textarea
                  label="Motivo"
                  type="text"
                  :rules="$validate(['required'])"
                  maxlength="500"
                  required
                  auto-grow
                  @input="verificarCompensacion(false)"
                  rows="2"
                  v-model="form.motivo"
                  outline
                  clearable
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md6 v-if="form.id_tipo_permiso == 61">
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_nacimiento"
                  label="Fecha de nacimiento"
                  @input="obtenerFechaSalidaYEntrada()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md6 v-if="form.id_tipo_permiso == 61">
                <v-text-field
                  class="text-field-reducido-border"
                  type="time"
                  v-model="form.hora_nacimiento"
                  label="Hora de nacimiento"
                  @input="obtenerFechaSalidaYEntrada()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 md6 v-if="form.id_tipo_permiso == 12">
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_matrimonio"
                  label="Fecha de matrimonio"
                  @input="obtenerFechaSalidaYEntrada()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md6 v-if="form.id_tipo_permiso == 6">
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_fallecimiento"
                  label="Fecha de fallecimiento"
                  @input="obtenerFechaSalidaYEntrada()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md6 v-if="form.id_tipo_permiso == 6">
                <v-text-field
                  class="text-field-reducido-border"
                  type="time"
                  v-model="form.hora_fallecimiento"
                  label="Hora de fallecimiento"
                  @input="obtenerFechaSalidaYEntrada()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
            </v-layout>
            <v-layout v-if="form.id_tipo_permiso == 45">
              <v-flex xs12 md6>
                <h4>Fechas programadas</h4>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <!-- DIAS DE CAPACITACION Y AGENTE CENSAL-->
              <v-flex xs12 v-if="form.id_tipo_permiso == 5">
                <v-select
                  class="text-field-reducido-border"
                  :items="capacitacion_censista"
                  item-value="id"
                  item-text="valor"
                  name="capacitacion_censista"
                  label="Seleccionar tipo de participación"
                  v-model="form.capacitacion_censista"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                  outline
                  :clearable="!primer_permiso_censo"
                  :readonly="!!primer_permiso_censo"
                  :disabled="!!primer_permiso_censo"
                ></v-select>
              </v-flex>
              <v-flex
                xs12
                v-if="form.capacitacion_censista && form.id_tipo_permiso == 5"
              >
                <v-alert
                  v-if="!!primer_permiso_censo"
                  class="text-xs-justify"
                  color="blue"
                  icon="done"
                  value="true"
                  outline
                >
                  {{
                    `Ya tiene creado el primer permiso de este tipo (Nro de papeleta:
                    ${primer_permiso_censo.numero}, 
                    ${primer_permiso_censo.fecha_desde}-
                    ${primer_permiso_censo.fecha_hasta} (${
                      primer_permiso_censo.dias
                    })dias), en el cual seleccionó la opción: ${
                      capacitacion_censista.filter(
                        ele =>
                          ele.id == primer_permiso_censo.id_parametro_permiso
                      )[0].valor
                    }`
                  }}
                </v-alert>
                <v-alert
                  v-if="form.capacitacion_censista == 135"
                  class="text-xs-justify"
                  color="indigo"
                  icon="warning"
                  value="true"
                  outline
                >
                  Se le otorga una (1) jornada laboral al personal que
                  habiendose capacitado fuera de horario laboral no fué
                  convocado por el INE para el día del empadronamiento D.S. 5097
                </v-alert>
                <v-alert
                  v-if="form.capacitacion_censista == 136"
                  class="text-xs-justify"
                  color="indigo"
                  icon="warning"
                  value="true"
                  outline
                >
                  Se le otorga dos (2) jornadas laborales al personal que
                  participo efectivamente el día del empadronamiento como
                  agentes censales enel Censo de Población y Vivienda 2024 D.S.
                  5097
                </v-alert>
              </v-flex>
            </v-layout>
            <v-layout>
              <!--  Licencia por paternidad .por duelo,por matrimonio-->
              <v-flex
                xs12
                md6
                v-if="
                  (form.fecha_fallecimiento &&
                    form.hora_fallecimiento &&
                    form.id_tipo_permiso == 6) ||
                    (form.fecha_matrimonio && form.id_tipo_permiso == 12) ||
                    (form.fecha_nacimiento &&
                      form.hora_nacimiento &&
                      form.id_tipo_permiso == 61)
                "
              >
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="fecha_desde2"
                  label="Fecha salida"
                  disabled
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>

              <v-flex
                xs12
                md6
                v-if="
                  form.id_tipo_permiso != 101 &&
                    form.id_tipo_permiso != 100 &&
                    form.id_tipo_permiso != 99 &&
                    form.id_tipo_permiso != 98 &&
                    form.id_tipo_permiso != 89 &&
                    form.id_tipo_permiso != 94 &&
                    form.id_tipo_permiso != 87 &&
                    form.id_tipo_permiso != 24 &&
                    form.id_tipo_permiso != 88 &&
                    form.id_tipo_permiso != 96 &&
                    form.id_tipo_permiso != 37 &&
                    form.id_tipo_permiso != 38 &&
                    form.id_tipo_permiso != 39 &&
                    form.id_tipo_permiso != 40 &&
                    form.id_tipo_permiso != 41 &&
                    form.id_tipo_permiso != 42 &&
                    form.id_tipo_permiso != 43 &&
                    form.id_tipo_permiso != 6 &&
                    form.id_tipo_permiso != 61 &&
                    form.id_tipo_permiso != 90 &&
                    form.id_tipo_permiso != 12 &&
                    form.id_tipo_permiso != 102 &&
                    form.id_tipo_permiso != 5
                "
              >
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha salida"
                  @change="calculaDiasHabiles()"
                  @input="obtenerSiguienteFecha()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <!--  Baja medica-->
              <v-flex
                xs12
                md6
                v-if="[90, 5].includes(parseInt(form.id_tipo_permiso))"
              >
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha salida"
                  @input="obtenerSiguienteFecha()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex
                xs12
                md6
                v-if="
                  [90, 5].includes(parseInt(form.id_tipo_permiso)) &&
                    form.fecha_desde &&
                    form.dias_incapacidad
                "
              >
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="fecha_resultante"
                  label="Fecha hasta"
                  @change="obtenerSiguienteFecha()"
                  disabled
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <!-- Campo fecha - Permiso dia de la madre p99 p88 -->
              <v-flex
                xs12
                md6
                v-if="
                  form.id_tipo_permiso == 101 ||
                    form.id_tipo_permiso == 100 ||
                    form.id_tipo_permiso == 99 ||
                    form.id_tipo_permiso == 98 ||
                    form.id_tipo_permiso == 87 ||
                    form.id_tipo_permiso == 88 ||
                    form.id_tipo_permiso == 96 ||
                    form.id_tipo_permiso == 89 ||
                    (form.id_tipo_permiso >= 37 && form.id_tipo_permiso <= 43)
                "
              >
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha"
                  @change="verificarCompensacion(true) && calculaDiasHabiles()"
                  @input="verificarCompensacion(false)"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <!--  Omision de registro de aistencias-->
              <v-flex xs12 md6 v-if="form.id_tipo_permiso == 94">
                <v-autocomplete
                  class="text-field-reducido-border"
                  :items="tipos_omision"
                  item-value="id"
                  item-text="valor"
                  v-model="form.id_tipo_omision"
                  label="Tipo de omisión"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md6 v-if="form.id_tipo_permiso == 94">
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha de omisión de marcado"
                  @change="calculaDiasHabiles()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <!-- HORARIOS DE PERMISOS-->
              <v-flex
                xs12
                md6
                v-if="form.id_tipo_permiso == 94 && form.id_tipo_omision == 2"
              >
                <v-autocomplete
                  class="text-field-reducido-border"
                  :items="permiso_omision"
                  :item-value="
                    val => {
                      return val;
                    }
                  "
                  :item-text="
                    val => {
                      return `${val.tipo_permiso} : ${val.fecha_desde} , ${val.hora_desde} - ${val.hora_hasta}`;
                    }
                  "
                  v-model="form.id_permiso_omision"
                  label="Seleccionar permiso (omisión de marcado)"
                  :rules="$validate(['required'])"
                  @input="obtenerHorarioLaboral()"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <!-- HORARIOS DE OMISIONES-->
              <v-flex
                xs12
                md6
                v-if="form.id_tipo_permiso == 94 && form.id_tipo_omision == 3"
              >
                <v-autocomplete
                  class="text-field-reducido-border"
                  :items="compensacion_omision"
                  :item-value="
                    val => {
                      return val;
                    }
                  "
                  :item-text="
                    val => {
                      return `${val.tipo_permiso} -${val.numero}: ${val.fecha_compensacion} , ${val.hora_desde} - ${val.hora_hasta}`;
                    }
                  "
                  v-model="form.id_compensacion_omision"
                  label="Seleccionar compensación (omisión de marcado)"
                  :rules="$validate(['required'])"
                  @input="obtenerHorarioLaboral()"
                  required
                  outline
                  clearable
                />
              </v-flex>
               <!-- OMISIONES POR COMISION DE VIAJE -->
               <v-flex
                xs12
                md6
                v-if="form.id_tipo_permiso == 94 && form.id_tipo_omision == 4"
              >
                <v-autocomplete
                  :items="compensacion_comisiones_viaje"
                  :item-value="
                    val => {
                      return val;
                    }
                  "
                  :item-text="
                    val => {
                      return `${val.cite} | ${$moment(val.fecha).format('DD/MM/YYYY')} | ${val.hora}`;
                    }
                  "
                  v-model="form.id_compensacion_omision"
                  label="Seleccionar comisión de viaje (omisión de marcado)"
                  :rules="$validate(['required'])"
                  @input="obtenerHorarioLaboral()"
                  required
                  outline
                  clearable
                />
              </v-flex>

              <!--  Licencia por paternidad .por duelo,por matrimonio-->
              <v-flex
                xs12
                md6
                v-if="
                  (form.fecha_fallecimiento &&
                    form.hora_fallecimiento &&
                    form.id_tipo_permiso == 6) ||
                    (form.fecha_matrimonio && form.id_tipo_permiso == 12) ||
                    (form.fecha_nacimiento &&
                      form.hora_nacimiento &&
                      form.id_tipo_permiso == 61)
                "
              >
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="fecha_hasta2"
                  label="Fecha hasta"
                  disabled
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <!--  TRABAJO CONTINUO nro 102-->
              <v-flex md6 xs12 v-if="form.id_tipo_permiso == 102">
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="fecha_trabajo_continuo"
                  @input="calculaHorarioDiscontinuo()"
                  label="Fecha"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md6 v-if="form.id_tipo_permiso == 102">
                <v-textarea
                  label="Motivo"
                  type="text"
                  :rules="$validate(['required'])"
                  maxlength="500"
                  required
                  auto-grow
                  rows="2"
                  v-model="form.motivo"
                  outline
                  clearable
                />
              </v-flex>
              <v-flex
                xs12
                md6
                v-if="
                  form.id_tipo_permiso != 101 &&
                    form.id_tipo_permiso != 100 &&
                    form.id_tipo_permiso != 99 &&
                    form.id_tipo_permiso != 98 &&
                    form.id_tipo_permiso != 14 &&
                    //form.id_tipo_permiso != 105 &&
                    form.id_tipo_permiso != 97 &&
                    form.id_tipo_permiso != 87 &&
                    form.id_tipo_permiso != 88 &&
                    form.id_tipo_permiso != 89 &&
                    form.id_tipo_permiso != 8 &&
                    form.id_tipo_permiso != 13 &&
                    form.id_tipo_permiso != 15 &&
                    form.id_tipo_permiso != 94 &&
                    form.id_tipo_permiso != 24 &&
                    form.id_tipo_permiso != 96 &&
                    form.id_tipo_permiso != 37 &&
                    form.id_tipo_permiso != 38 &&
                    form.id_tipo_permiso != 39 &&
                    form.id_tipo_permiso != 40 &&
                    form.id_tipo_permiso != 41 &&
                    form.id_tipo_permiso != 42 &&
                    form.id_tipo_permiso != 43 &&
                    form.id_tipo_permiso != 90 &&
                    form.id_tipo_permiso != 6 &&
                    form.id_tipo_permiso != 61 &&
                    form.id_tipo_permiso != 12 &&
                    form.id_tipo_permiso != 102 &&
                    form.id_tipo_permiso != 5
                "
              >
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_hasta"
                  label="Fecha hasta"
                  @change="calculaDiasHabiles()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex v-if="form.id_tipo_permiso == 45 || form.id_tipo_permiso == 105">
                <p>
                  <strong>Total Días:</strong>
                  {{ this.dias_habiles }}
                </p>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex v-if="form.id_tipo_permiso == 45">
                <v-radio-group
                  v-model="radio_data_programacion"
                  row
                  :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    }
                  ]"
                >
                  <v-flex xs4>
                    <v-radio label="Todo el día" :value="0"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo mañana" :value="1"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo tarde" :value="2"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout v-if="form.id_tipo_permiso == 45">
              <v-flex md12>
                <h4>Fechas de reprogramacion</h4>
              </v-flex>
            </v-layout>
            <v-layout v-if="form.id_tipo_permiso == 45">
              <v-flex xs12 md6 v-if="form.id_tipo_permiso == 45">
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_desde_reprogramacion"
                  label="Fecha desde"
                  @change="calculaDiasHabiles()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md6 v-if="form.id_tipo_permiso == 45">
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="form.fecha_hasta_reprogramacion"
                  label="Fecha hasta"
                  @change="calculaDiasHabiles()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex v-if="form.id_tipo_permiso == 45">
                <p>
                  <strong>Total Días:</strong>
                  {{ this.dias_habiles }}
                </p>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex v-if="form.id_tipo_permiso == 45">
                <v-radio-group
                  v-model="radio_data_reprogramacion"
                  row
                  :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    }
                  ]"
                >
                  <v-flex xs4>
                    <v-radio label="Todo el día" :value="0"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo mañana" :value="1"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo tarde" :value="2"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md6 xs12 v-if="form.id_tipo_permiso == 102">
                <v-text-field
                  class="text-field-reducido-border"
                  type="time"
                  v-model="hora_desde_trabajo_continuo"
                  label="Hora desde"
                  disabled
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex md6 xs12 v-if="form.id_tipo_permiso == 102">
                <v-text-field
                  class="text-field-reducido-border"
                  type="time"
                  v-model="hora_hasta_trabajo_continuo"
                  label="Hora hasta"
                  disabled
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex
                xs12
                md6
                v-if="[90, 5].includes(parseInt(form.id_tipo_permiso))"
              >
                <v-text-field
                  class="text-field-reducido-border"
                  :value="val => parseInt(val)"
                  name="dias_incapacidad"
                  :label="
                    form.id_tipo_permiso == 90
                      ? 'Días de incapacidad'
                      : form.id_tipo_permiso == 5
                      ? 'Dias a solicitar'
                      : ''
                  "
                  v-model="form.dias_incapacidad"
                  type="number"
                  @change="obtenerSiguienteFecha()"
                  @input="obtenerSiguienteFecha()"
                  autofocus
                  :rules="[v => v > 0 || `Introduzca un valor mayor a 0`]"
                  maxlength="500"
                  required
                  outline
                  clearable
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md6 v-if="form.id_tipo_permiso == 45">
                <v-autocomplete
                  class="text-field-reducido-border"
                  :items="justificaciones_solicitud"
                  item-value="descripcion"
                  item-text="descripcion"
                  v-model="form.justificacion_solicitud"
                  label="Justificacion de la solicitud"
                  maxlength="150"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
                <!-- :disabled="permiso_detalles.length > 0" -->
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md6 v-if="form.justificacion_solicitud == 'Otros'">
                <v-textarea
                  label="Otros"
                  maxlength="150"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
                <!-- :disabled="permiso_detalles.length > 0" -->
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex
                xs12
                md6
                v-if="
                  form.id_tipo_permiso != 101 &&
                    form.id_tipo_permiso != 100 &&
                    form.id_tipo_permiso != 99 &&
                    form.id_tipo_permiso != 98 &&
                    form.id_tipo_permiso != 61 &&
                    form.id_tipo_permiso != 6 &&
                    form.id_tipo_permiso != 12 &&
                    form.id_tipo_permiso != 14 &&
                    form.id_tipo_permiso != 105 &&
                    form.id_tipo_permiso != 89 &&
                    form.id_tipo_permiso != 15 &&
                    form.id_tipo_permiso != 13 &&
                    form.id_tipo_permiso != 17 &&
                    form.id_tipo_permiso != 16 &&
                    form.id_tipo_permiso != 90 &&
                    form.id_tipo_permiso != 18 &&
                    form.id_tipo_permiso != 24 &&
                    form.id_tipo_permiso != 94 &&
                    form.id_tipo_permiso != 95 &&
                    form.id_tipo_permiso != 37 &&
                    form.id_tipo_permiso != 38 &&
                    form.id_tipo_permiso != 39 &&
                    form.id_tipo_permiso != 40 &&
                    form.id_tipo_permiso != 41 &&
                    form.id_tipo_permiso != 42 &&
                    form.id_tipo_permiso != 43 &&
                    form.id_tipo_permiso != 44 &&
                    form.id_tipo_permiso != 45 &&
                    form.id_tipo_permiso != 102 &&
                    form.id_tipo_permiso != 5
                "
              >
                <v-text-field
                  class="text-field-reducido-border"
                  type="time"
                  label="Hora desde"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  v-model="form.hora_desde"
                  @change="validaPermisoPersonalGoce()"
                />
              </v-flex>

              <v-flex
                xs12
                md6
                v-if="
                  form.id_tipo_permiso != 101 &&
                    form.id_tipo_permiso != 100 &&
                    form.id_tipo_permiso != 99 &&
                    form.id_tipo_permiso != 98 &&
                    form.id_tipo_permiso != 61 &&
                    form.id_tipo_permiso != 6 &&
                    form.id_tipo_permiso != 12 &&
                    form.id_tipo_permiso != 14 &&
                    form.id_tipo_permiso != 105 &&
                    form.id_tipo_permiso != 89 &&
                    form.id_tipo_permiso != 15 &&
                    form.id_tipo_permiso != 13 &&
                    form.id_tipo_permiso != 17 &&
                    form.id_tipo_permiso != 16 &&
                    form.id_tipo_permiso != 90 &&
                    form.id_tipo_permiso != 18 &&
                    form.id_tipo_permiso != 24 &&
                    form.id_tipo_permiso != 94 &&
                    form.id_tipo_permiso != 95 &&
                    form.id_tipo_permiso != 37 &&
                    form.id_tipo_permiso != 38 &&
                    form.id_tipo_permiso != 39 &&
                    form.id_tipo_permiso != 40 &&
                    form.id_tipo_permiso != 41 &&
                    form.id_tipo_permiso != 42 &&
                    form.id_tipo_permiso != 43 &&
                    form.id_tipo_permiso != 44 &&
                    form.id_tipo_permiso != 45 &&
                    form.id_tipo_permiso != 102 &&
                    form.id_tipo_permiso != 5
                "
              >
                <!-- @input="
                      verificarRangoMediaHora(false) &&
                        verificarCompensacion(false)
                    " -->
                <v-text-field
                  class="text-field-reducido-border"
                  type="time"
                  label="Hora hasta"
                  :rules="$validate(['required'])"
                  required
                  v-model="form.hora_hasta"
                  outline
                  clearable
                  @change="validaPermisoPersonalGoce()"
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex
                v-if="form.id_tipo_permiso >= 37 && form.id_tipo_permiso <= 43"
              >
                <v-radio-group
                  v-model="radio_data"
                  row
                  :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    }
                  ]"
                >
                  <v-flex xs6>
                    <v-radio label="Mañana" :value="'toda-mañana'"></v-radio>
                  </v-flex>
                  <v-flex xs6>
                    <v-radio label="Tarde" :value="'toda-tarde'"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <p
              v-if="
                form.id_tipo_permiso == 12 ||
                  form.id_tipo_permiso == 97 ||
                  form.id_tipo_permiso == 87 ||
                  (form.id_tipo_permiso == 103) ||
                    (form.id_tipo_permiso == 90) ||
                  form.id_tipo_permiso == 61 ||
                  form.id_tipo_permiso == 6 ||
                  form.id_tipo_permiso == 95 ||
                  form.id_tipo_permiso == 44 ||
                  (form.id_tipo_permiso >= 37 && form.id_tipo_permiso <= 43)
              "
            ></p>
            <!-- para adjuntos no obligatorios-->
            <v-layout>
              <v-flex
                xs12
                v-if="form.id_tipo_permiso == 97 || form.id_tipo_permiso == 87"
              >
                <div
                  :class="this.file == '' ? 'archivo_vacio' : 'archivo_cargado'"
                >
                  <v-icon>{{
                    this.file == "" ? "file_upload" : "done"
                  }}</v-icon>
                  <input
                    class="input-file"
                    type="file"
                    @change="handleFileUpload()"
                    ref="file"
                    accept="application/pdf"
                  />
                  {{
                    this.file == "" && form.id_tipo_permiso == 90
                      ? "Adjuntar baja médica emitida por el ente gestor de salud"
                      : this.file == "" && form.id_tipo_permiso == 44
                      ? "Adjuntar informe emitido por la URH y respaldos"
                      : this.file == "" && form.id_tipo_permiso == 6
                      ? "Adjuntar certificado de defuncion emitido por el registro civil"
                      : this.file == "" &&
                        form.id_tipo_permiso >= 37 &&
                        form.id_tipo_permiso <= 43
                      ? "Adjuntar formulario otorgado por el servicio médico (Art. 3 Decreto supremo Nº 3164)"
                      : this.file == "" && form.id_tipo_permiso == 12
                      ? "Adjuntar certificado de matrimonio emitido por el registro civil"
                      : this.file == "" && form.id_tipo_permiso == 61
                      ? "Adjuntar el certificado de nacimiento emitido por el registro civil"
                      : this.file == "" &&
                        form.id_tipo_permiso != 90 &&
                        form.id_tipo_permiso != 12 &&
                        form.id_tipo_permiso != 61 &&
                        form.id_tipo_permiso != 44 &&
                        form.id_tipo_permiso != 37 &&
                        form.id_tipo_permiso != 38 &&
                        form.id_tipo_permiso != 39 &&
                        form.id_tipo_permiso != 40 &&
                        form.id_tipo_permiso != 41 &&
                        form.id_tipo_permiso != 43 &&
                        form.id_tipo_permiso != 42
                      ? "Adjuntar respaldo"
                      : this.file.name
                  }}
                </div>
                <p class="red--text body-1" v-if="errors.denied">
                  *Formato no admitido por el sistema
                </p>
              </v-flex>
            </v-layout>
            <!-- para adjuntos obligatorios-->
            <v-layout>
              <v-flex
                xs12
                v-if="
                  form.id_tipo_permiso == 12 ||
                    form.id_tipo_permiso == 18 ||
                    form.id_tipo_permiso == 8 ||
                    form.id_tipo_permiso == 103 ||
                    form.id_tipo_permiso == 5
                "
              >
                <div
                  :class="this.file == '' ? 'archivo_vacio' : 'archivo_cargado'"
                >
                  <v-icon>{{
                    this.file == "" ? "file_upload" : "done"
                  }}</v-icon>

                  <input
                    class="input-file"
                    type="file"
                    @change="handleFileUpload2()"
                    ref="file"
                    accept="application/pdf"
                    :rules="$validate(['required'])"
                    required
                  />
                  {{
                    this.file == "" && form.id_tipo_permiso == 90
                      ? "Adjuntar baja médica emitida por el ente gestor de salud"
                      : this.file == "" && form.id_tipo_permiso == 44
                      ? "Adjuntar informe emitido por la URH y respaldos"
                      : this.file == "" &&
                        form.id_tipo_permiso == 5 &&
                        form.capacitacion_censista == 135
                      ? "Adjuntar certificado que acredite la capacitación"
                      : this.file == "" &&
                        form.id_tipo_permiso == 5 &&
                        form.capacitacion_censista == 136
                      ? "Adjuntar certificado que acredite la participación activa al CENSO"
                      : this.file == "" && form.id_tipo_permiso == 6
                      ? "Adjuntar certificado de defuncion emitido por el registro civil"
                      : this.file == "" &&
                        form.id_tipo_permiso >= 37 &&
                        form.id_tipo_permiso <= 43
                      ? "Adjuntar formulario otorgado por el servicio médico (Art. 3 Decreto supremo Nº 3164)"
                      : this.file == "" && form.id_tipo_permiso == 12
                      ? "Adjuntar certificado de matrimonio emitido por el registro civil"
                      : this.file == "" && form.id_tipo_permiso == 61
                      ? "Adjuntar el certificado de nacimiento emitido por el registro civil"
                      : this.file == "" && form.id_tipo_permiso == 8
                      ? "ADJUNTAR JUSTIFICATIVO"
                      : this.file == "" &&
                        form.id_tipo_permiso != 90 &&
                        form.id_tipo_permiso != 12 &&
                        form.id_tipo_permiso != 8 &&
                        form.id_tipo_permiso != 61 &&
                        form.id_tipo_permiso != 44 &&
                        form.id_tipo_permiso != 37 &&
                        form.id_tipo_permiso != 38 &&
                        form.id_tipo_permiso != 39 &&
                        form.id_tipo_permiso != 40 &&
                        form.id_tipo_permiso != 41 &&
                        form.id_tipo_permiso != 43 &&
                        form.id_tipo_permiso != 42
                      ? "Adjuntar respaldo"
                      : this.file.name
                  }}
                </div>
                <p class="red--text body-1" v-if="errors2.file">
                  *Debe seleccionar un archivo
                </p>

                <p class="red--text body-1" v-if="errors2.denied">
                  *Formato no admitido por el sistema
                </p>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex
                xs12
                v-if="
                  form.id_tipo_permiso == 6 ||
                    form.id_tipo_permiso == 61 ||
                    form.id_tipo_permiso == 95 ||
                    form.id_tipo_permiso == 44 ||
                    form.id_tipo_permiso == 90 ||
                    (form.id_tipo_permiso >= 37 && form.id_tipo_permiso <= 43)
                "
              >
                <div
                  :class="this.file == '' ? 'archivo_vacio' : 'archivo_cargado'"
                >
                  <v-icon>{{
                    this.file == "" ? "file_upload" : "done"
                  }}</v-icon>
                  <input
                    class="input-file"
                    type="file"
                    @change="handleFileUpload2()"
                    ref="file"
                    accept="application/pdf"
                    :rules="$validate(['required'])"
                    required
                    outline
                    clearable
                  />
                  {{
                    this.file == "" && form.id_tipo_permiso == 90
                      ? "Adjuntar baja médica emitida por el ente gestor de salud"
                      : this.file == "" && form.id_tipo_permiso == 44
                      ? "Adjuntar informe emitido por la URH y respaldos"
                      : this.file == "" && form.id_tipo_permiso == 6
                      ? "Adjuntar certificado de defuncion emitido por el registro civil"
                      : this.file == "" &&
                        form.id_tipo_permiso >= 37 &&
                        form.id_tipo_permiso <= 43
                      ? "Adjuntar formulario otorgado por el servicio médico (Art. 3 Decreto supremo Nº 3164)"
                      : this.file == "" && form.id_tipo_permiso == 12
                      ? "Adjuntar certificado de matrimonio emitido por el registro civil"
                      : this.file == "" && form.id_tipo_permiso == 61
                      ? "Adjuntar el certificado de nacimiento emitido por el registro civil"
                      : this.file == "" &&
                        form.id_tipo_permiso != 90 &&
                        form.id_tipo_permiso != 12 &&
                        form.id_tipo_permiso != 61 &&
                        form.id_tipo_permiso != 44 &&
                        form.id_tipo_permiso != 37 &&
                        form.id_tipo_permiso != 38 &&
                        form.id_tipo_permiso != 39 &&
                        form.id_tipo_permiso != 40 &&
                        form.id_tipo_permiso != 41 &&
                        form.id_tipo_permiso != 43 &&
                        form.id_tipo_permiso != 42
                      ? "Adjuntar respaldo"
                      : this.file.name
                  }}
                </div>
                <p class="red--text body-1" v-if="errors2.file">
                  *Debe seleccionar un archivo
                </p>

                <p class="red--text body-1" v-if="errors2.denied">
                  *Formato no admitido por el sistema
                </p>
              </v-flex>
            </v-layout>
            <v-flex
              v-if="
                form.hora_hasta != null &&
                  form.hora_desde != null &&
                  form.fecha_desde != null &&
                  (form.id_tipo_permiso == 14 )
              "
            >
              <p>
                <strong>Total Horas:</strong>
                {{
                  $moment(form.hora_hasta, "hh:mm")
                    .subtract(form.hora_desde, "hh:mm")
                    .format("hh:mm")
                }}
              </p>
            </v-flex>

            <!---    SOLO DIAS PARA SUMAR  -->
            <v-flex v-if="form.id_tipo_permiso == 18">
              <p>
                <strong>Total Días:</strong>{{ this.dias }}
                {{ this.dias_habiles }}
              </p>
            </v-flex>
            <!--   *****************************FORMULARIO DE REGISTRO DE ASISTENCIA P94 ****************************** -->
            <v-layout xs12 v-if="form.id_tipo_permiso == 94"
              ><v-flex xs12 md6>
                <v-radio-group
                  v-if="form.id_tipo_omision == 2"
                  v-model="form.tipo_horario"
                  @change="obtenerHorarioLaboral()"
                >
                  <v-radio label="Salida" value="2"></v-radio>
                  <v-radio label="Retorno" value="1"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 md6>
                <v-radio-group
                  v-if="form.id_tipo_omision == 1 && form.fecha_desde"
                  v-model="form.tipo_dia"
                  @change="obtenerHorarioLaboral()"
                >
                  <v-flex>
                    <v-radio label="Mañana" value="1"></v-radio>
                  </v-flex>
                  <v-flex>
                    <v-radio label="Tarde" value="2"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 md6>
                <v-radio-group
                  v-if="form.id_tipo_omision == 1 && form.fecha_desde"
                  v-model="form.tipo_horario"
                  @change="obtenerHorarioLaboral()"
                >
                  <v-radio label="Ingreso" value="1"></v-radio>
                  <v-radio label="Salida" value="2"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-flex
              xs12
              md12
              v-if="form.id_tipo_permiso == 13 || form.id_tipo_permiso == 15"
            >
              <v-radio-group
                v-model="radio_data"
                row
                :rules="[
                  v => {
                    if (v == null) return 'El campo es obligatorio.';
                    return true;
                  }
                ]"
              >
                <v-flex xs6>
                  <v-radio label="Solo mañana" :value="'toda-mañana'"></v-radio>
                </v-flex>
                <v-flex xs6>
                  <v-radio label="Solo tarde" :value="'toda-tarde'"></v-radio>
                </v-flex>
              </v-radio-group>
            </v-flex>
            <v-layout>
              <v-flex xs12 md12 v-if="(form.id_tipo_permiso == 14 )">
                <v-radio-group
                  v-model="radio_data"
                  row
                  :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    }
                  ]"
                >
                  <v-flex xs4>
                    <v-radio label="Todo el día" :value="0"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo mañana" :value="1"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo tarde" :value="2"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex
                xs12
                md6
                v-if="
                  form.id_tipo_permiso == 101 ||
                    form.id_tipo_permiso == 100 ||
                    form.id_tipo_permiso == 99 ||
                    form.id_tipo_permiso == 98 ||
                    form.id_tipo_permiso == 89
                "
              >
                <v-radio-group
                  v-model="radio_data"
                  row
                  :rules="$validate(['required'])"
                  required
                >
                  <v-flex xs4>
                    <v-radio label="Solo mañana" :value="1"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo tarde" :value="2"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 md6 v-if="form.id_tipo_permiso == 94">
                <v-text-field
                  class="text-field-reducido-border"
                  type="time"
                  label="Hora"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  disabled
                  v-model="hora_calculada"
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <p v-if="form.id_tipo_permiso == 94">
                <strong>Nota.-</strong>
                <strong
                  >Se le recomienda tener mayor cuidado y responsabilidad,
                  debido a que su reincidencia sera sancionada de acuerdo al
                  Reglamento Interno de Personal.</strong
                >
              </p>
            </v-layout>
            <v-layout  v-if="false">
              <p v-if="form.id_tipo_permiso == 8">
                <strong
                  >Usted cuenta con 25 min. de tolerancia antes y
                  despues</strong
                >
              </p>
            </v-layout>

            <v-flex v-if="form.id_tipo_permiso != 24">
              <v-btn
                color="primary"
                @click="save()"
                v-if="
                  (form.id_tipo_permiso != 96 &&
                    form.id_tipo_permiso != 8 &&
                    form.id_tipo_permiso != 12 &&
                    form.id_tipo_permiso != 18 &&
                    !bandera_compensacion &&
                    bandera_media_hora &&
                    !bandera_8horas) ||
                    form.id_tipo_permiso == 94 ||
                    ((form.id_tipo_permiso == 8 ||
                      form.id_tipo_permiso == 12 ||
                      form.id_tipo_permiso == 18 ||
                      form.id_tipo_permiso == 103 ||
                      form.id_tipo_permiso == 6 ||
                      form.id_tipo_permiso == 61 ||
                      form.id_tipo_permiso == 95 ||
                      form.id_tipo_permiso == 44 ||
                      form.id_tipo_permiso == 90 ||
                      (form.id_tipo_permiso >= 37 &&
                        form.id_tipo_permiso <= 43)) &&
                      (!file || file != ''))
                "
              >
                <v-icon>save</v-icon>
                Guardar
              </v-btn>
              <v-btn
                v-if="
                  getRuta() == getPersonaId() &&
                    !bandera_compensacion &&
                    form.id_tipo_permiso != 96
                "
                color="error"
                :to="`/permisos/usuario/${getPersonaId()}`"
              >
                <v-icon>clear</v-icon>
                Cancelar
              </v-btn>
            </v-flex>
            <v-flex md6 v-if="form.id_tipo_permiso == 24">
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                @click.prevent="crearPermisoCargoVacacion()"
              >
                <v-icon>arrow_downward</v-icon>
                Continuar
              </v-btn>
            </v-flex>
          </v-container>
        </v-form>
      </v-card-text>
      <!-- Template permiso con goce de haberes COMPENSACION -->

      <compensacion
        v-if="
          bandera_compensacion &&
            bandera_media_hora &&
            !bandera_8horas &&
            form.id_tipo_permiso == 88
        "
        :item="form"
        :horas_compensacion="horas_compensacion"
        :ruta_ar="file"
        :estado_a="estado_a"
      />

      <compensacion-tolerancia
        v-if="form.id_tipo_permiso == 96 && bandera_media_hora"
        :item="form"
        :id_persona="id_persona_permiso"
        :rol="4"
      />
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import validate from "@/common/mixins/validate";
import EditarPermisoDetalle from "./dialogs/EditarPermisoDetalle.vue";
import CrearPermisoCargoVacacion from "../papeleta_vacacion/dialogs/CrearPermisoCargoVacacion.vue";
import Compensacion from "./components/Compensacion.vue";
import CompensacionTolerancia from "./components/CompensacionTolerancia.vue";
const pause = ms => new Promise(resolve => setTimeout(resolve, ms));

export default {
  components: { EditarPermisoDetalle, Compensacion, CompensacionTolerancia },
  mixins: [validate, crud],
  //mixins: [crud],
  data() {
    return {
      form: {},
      id_persona_permiso: this.$route.params.id,
      valid: false,
      validated: 0,
      errors: {
        denied: false
      },
      estado_a: 1,
      errors2: {
        file: false,

        denied: false
      },
      loading: false,
      bandera_calcula_sig_fecha: false,
      tipo_permisos: [],
      tipo_subpermisos: [],
      list_causal_permiso_sin_goce: [],
      fecha_hasta_calculada: "21-05-2022",
      fecha_desde2: "",
      fecha_hasta2: "",
      minuto_calculado: null,
      esUsuario: this.$route.params.id == null,
      permiso_detalles: [],
      fecha_trabajo_continuo: null,
      hora_desde_trabajo_continuo: null,
      hora_hasta_trabajo_continuo: null,
      tipos_baja: [
        { id: 1, descripcion: "PRENATAL" },
        { id: 2, descripcion: "POST NATAL" },
        {
          id: 3,
          descripcion:
            "OTROS(ENFERMEDAD COMUN,RIESGO PROFESIONAL, RIESGO EXTRAORDINARIO)"
        }
      ],
      id_tipo_permi: "",
      hoy: "",
      dias: "",
      fecha_resultante: "",
      dias_habiles: 0,
      bandera_compensacion: false,
      bandera_media_hora: true,
      bandera_8horas: false,
      horas_compensacion: 0,
      loading_boton: false,
      rol: [],
      file: "",
      headers: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        },
        {
          text: "Acción",
          sortable: false,
          align: "center"
        }
      ],
      count_id: 0,
      tiempos_radio: {
        "todo-dia": {
          hora_desde: "08:30",
          hora_hasta: "16:30"
        },
        "toda-mañana": {
          hora_desde: "08:30",
          hora_hasta: "12:30"
        },
        "toda-tarde": {
          hora_desde: "12:30",
          hora_hasta: "16:30"
        }
      },
      radio_data: "",
      tipos_omision: [
        { id: 1, valor: "OMISIÓN DE MARCADO HORARIO REGULAR" },
        { id: 2, valor: "OMISIÓN DE MARCADO PAPELETA DE PERMISO" },
        //{ id: 3, valor: "OMISIÓN DE COMPENSACIONES" },
        //{ id: 4, valor: "OMISIÓN DE MARCADO COMISIÓN DE VIAJE" }
      ],
      permiso_omision: [],
      compensacion_omision: [],
      compensacion_comisiones_viaje: [],
      radio_data_reprogramacion: "",
      radio_data_programacion: "",
      justificaciones_solicitud: [
        {
          id: 1,
          descripcion: "Indole personal"
        },
        {
          id: 2,
          descripcion: "Por motivos de viaje"
        },
        {
          id: 3,
          descripcion: "Por temas legales"
        },
        {
          id: 4,
          descripcion: "Otros"
        }
      ],
      elaborado: [],
      // Variable permiso - Formulario de registro de asistencia
      tipo_horario: null,
      tipo_dia: null,
      hora_calculada: null,
      // Variables censo
      capacitacion_censista: [],
      primer_permiso_censo: null
    };
  },
  async mounted() {
    this.obtenerTipoPermiso();
    await this.obtenerPermisosPersonaOmision();
    await this.obtenerComisionesViajeOmision();
    await this.obtenerAgenteCapacitacion();
    await this.obtenerCompensacionesOmision();
    await this.getCausalesSinGoce();
    this.CalcularDias();
    this.obtenerLugarAtencion();
  },
  methods: {
    // Metodo para validar permiso personal con goce de haber
    async validaPermisoPersonalGoce() {
      await this.verificarRangoMediaHora(true);
      await this.verificarCompensacion(true);
    },
    // Metodo para cargar datos de un permiso censo si existe
    async verificaCenso(id_tipo_permiso) {
      try {
        if (id_tipo_permiso == 5) {
          // Buscamos si existe el permiso inicial
          console.log(
            "---",
            `select control.fn_busca_permiso_censo_2024(${this.getPersonaId()})`
          );
          let res = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_busca_permiso_censo_2024(${this.getPersonaId()})"){
                  respuesta
                }
              }
            `
          });
          let rpta_censo =
            res.runQuery.respuesta[0].fn_busca_permiso_censo_2024;
          rpta_censo = rpta_censo.split("|");
          // Preguntamos si existe el permiso
          if (rpta_censo[0] == "1" && rpta_censo[1]) {
            this.primer_permiso_censo = JSON.parse(rpta_censo[1])[0];
            // PONEMOS EL TIPO DE CAPACITACION
            var form_tmp = JSON.parse(JSON.stringify(this.form));
            form_tmp.capacitacion_censista = this.primer_permiso_censo.id_parametro_permiso;
            this.form = form_tmp;
          } else {
            this.primer_permiso_censo = null;
          }
        } else {
          this.primer_permiso_censo = null;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerAgenteCapacitacion() {
      try {
        let res = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select p.id,p.valor,(select count(per.id) from control.permiso per where per.id_persona=${this.getPersonaId()} and per.id_tipo_permiso=5 and per.id_estado not in (9))as nro_permisos from general.parametro p where p.tipo like 'capacitacion_agente'"){
                  respuesta
                }
              }
            `
        });
        this.capacitacion_censista = res.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    //Asignar variables iniciales de fechas:
    async obtenerFechasIniciales(id_tipo_permiso) {
      try {
        if (id_tipo_permiso == 6) {
          //duelo
          this.form.fecha_fallecimiento = this.$moment(new Date()).format(
            "YYYY-MM-DD"
          );
        }
        if (id_tipo_permiso == 61) {
          //paternidad
          this.form.fecha_nacimiento = this.$moment(new Date()).format(
            "YYYY-MM-DD"
          );
        }
        if (id_tipo_permiso == 12) {
          //matrimonio
          this.form.fecha_matrimonio = this.$moment(new Date()).format(
            "YYYY-MM-DD"
          );
          await this.obtenerFechaSalidaYEntrada();
        }
        if (
          (id_tipo_permiso >= 98 && id_tipo_permiso <= 101) ||
          id_tipo_permiso == 96 ||
          id_tipo_permiso == 87 ||
          id_tipo_permiso == 103 ||
          id_tipo_permiso == 88 ||
          id_tipo_permiso == 89 ||
          (id_tipo_permiso >= 37 && id_tipo_permiso <= 43)
        ) {
          //
          this.form.fecha_desde = this.$moment(new Date()).format("YYYY-MM-DD");
        }
        if (id_tipo_permiso == 95) {
          // teletrabajo
          this.form.fecha_hasta = this.$moment(new Date()).format("YYYY-MM-DD");
        }
        if (id_tipo_permiso == 95) {
          // teletrabajo
          this.form.fecha_desde = this.$moment(new Date()).format("YYYY-MM-DD");
        }
      } catch (error) {
        console.log(error);
      }
    },
    //obtener permisos persona, para registrar la omision de marcado
    async obtenerPermisosPersonaOmision() {
      try {
        let id_persona = this.getPersonaId();
        this.permiso_omision = [];
        let res = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta: "select * from control.v_permisos_por_funcionario vppf where vppf.id_persona =${id_persona} and vppf.id_estado in (77,7,75) order by vppf.fecha_desde desc"){
                  respuesta
                }
              }
            `
        });

        this.permiso_omision = res.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
     //obtener comisiones de viaje, para registrar la omision de marcado
     async obtenerComisionesViajeOmision() {
      try {
        let id_persona = this.getPersonaId();
        this.compensacion_comisiones_viaje = [];
        let res = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta: "select vc.cite ,vc.fecha ,vc.hora from control.v_comision_persona_omision vc where vc.id_persona = ${parseInt(
                  id_persona
                )} order by vc.fecha desc, vc.hora desc"){
                  respuesta
                }
              }
            `
        });
        this.compensacion_comisiones_viaje = res.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    //obtener compensaciomnes, para registrar la omision de marcado
    async obtenerCompensacionesOmision() {
      try {
        let id_persona = this.getPersonaId();
        this.compensacion_omision = [];
        let res = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta: "select tp.descripcion as tipo_permiso, p.numero , pc.id_permiso ,pc.hora_desde ,pc.hora_hasta,pc.fecha_desde fecha_compensacion,p.id_persona ,pd.fecha_desde as fecha_permiso from control.permiso_compensacion pc , control.permiso p,control.tipo_permiso tp ,control.permiso_detalle pd where p.id=pc.id_permiso and tp.id=p.id_tipo_permiso and p.id_persona = ${parseInt(
                  id_persona
                )} and p.id_estado in (77,7) and pd.id_permiso =p.id order by pc.fecha_desde desc"){
                  respuesta
                }
              }
            `
        });
        this.compensacion_omision = res.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    // Obtener horario de entrada o salida, continuo -dicontinuo
    async obtenerHorarioLaboral() {
      this.hora_calculada = null;
      try {
        if (!this.form.fecha_desde) {
          this.$message.info("Ingrese una fecha");
          return;
        }
        if (this.form.id_tipo_omision == 1) {
          if (this.form.tipo_dia && this.form.tipo_horario) {
            let id_persona = this.getPersonaId();
            ///permiso 94 formulario de registro de asistenncia
            if (this.form.id_tipo_permiso == 94) {
              let respuesta = await this.$service.graphql({
                query: `
                  query{
                    runQuery(consulta:"select control.fn_obtiene_horarios_ingreso_salida_persona(${id_persona},${parseInt(
                  this.form.tipo_dia
                )},${parseInt(this.form.tipo_horario)},'${
                  this.form.fecha_desde
                }')"){
                      respuesta
                    }
                  }
                `
              });
              if (
                respuesta.runQuery.respuesta[0]
                  .fn_obtiene_horarios_ingreso_salida_persona ||
                respuesta.runQuery.respuesta[0]
                  .fn_obtiene_horarios_ingreso_salida_persona != null
              ) {
                respuesta =
                  respuesta.runQuery.respuesta[0]
                    .fn_obtiene_horarios_ingreso_salida_persona;
                let horarios = respuesta.split("|");
                console.log(horarios);
                if (horarios[0] == "1") {
                  this.hora_calculada = horarios[1];
                } else {
                  this.mensaje_error = horarios[1];
                  this.$message.info(this.mensaje_error);
                }
              }
            }
          }
        }
        if (this.form.id_tipo_omision == 2) {
          // salida=2  , retorno =1 s
          if (this.form.id_permiso_omision && this.form.tipo_horario) {
            let id_persona = this.getPersonaId();
            ///permiso 94 formulario de registro de asistenncia
            if (this.form.id_tipo_permiso == 94) {
              if (this.form.tipo_horario == 2) {
                this.hora_calculada = this.form.id_permiso_omision.hora_desde;
              }
              if (this.form.tipo_horario == 1) {
                this.hora_calculada = this.form.id_permiso_omision.hora_hasta;
              }
            }
          }
        }
        if (this.form.id_tipo_omision == 3) {
          // salida=2  , retorno =1
          if (this.form.id_compensacion_omision.hora_hasta) {
            let id_persona = this.getPersonaId();
            ///permiso 94 formulario de registro de asistenncia
            if (this.form.id_tipo_permiso == 94) {
              this.hora_calculada = this.form.id_compensacion_omision.hora_hasta;
            }
          }
        }
        // COmisiones de viaje
        if (this.form.id_tipo_omision == 4) {
          if (this.form.id_compensacion_omision.hora) {
            if (this.form.id_tipo_permiso == 94) {
              this.hora_calculada = this.form.id_compensacion_omision.hora;
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    //verifica que una vacacion aprobada no choque con el permiso:
    async verificaVacaciones(fecha_desde, fecha_hasta) {
      let existe_vacacion = false;
      let permisos_consulta = "";
      let respuesta;
      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select vacaciones.fn_verifica_coincidencia_de_vacaciones_aprobadas(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}')"){
                  respuesta
                }
              }
            `
        });
        respuesta =
          respuesta.runQuery.respuesta[0]
            .fn_verifica_coincidencia_de_vacaciones_aprobadas;

        if (respuesta != "0") {
          existe_vacacion = true;
          permisos_consulta +=
            "<br><strong>Usted tiene la siguiente vacación aprobada en las fechas solicitadas:</strong><br>" +
            respuesta.replace(/#/g, "<br>");
          this.$message.warning(permisos_consulta);
        }
        return existe_vacacion;
      } catch (error) {
        console.log(error);
      }
    },
    async verificarRangoMediaHora(bandera_mensaje) {
      if (
        (parseInt(this.form.id_tipo_permiso) == 88 ||
          parseInt(this.form.id_tipo_permiso) == 96) &&
        this.form.hora_desde &&
        this.form.hora_hasta
      ) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
                query{
                  runQuery(consulta:"select control.fn_valida_rangos_media_hora('${this.form.hora_desde}','${this.form.hora_hasta}')"){
                    respuesta
                  }
                }
              `
          });
          respuesta =
            respuesta.runQuery.respuesta[0].fn_valida_rangos_media_hora;
          respuesta = respuesta.split("|");
          if (respuesta[0] == "1") {
            this.bandera_media_hora = true;
          } else {
            if (bandera_mensaje) {
              this.$message.info(respuesta[1]);
            }
            this.bandera_media_hora = false;
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async verificarCompensacion(bandera_mensaje) {
      if (this.form.id_tipo_permiso == 96 && this.form.hora_hasta) {
        let minutos1 = this.form.hora_hasta.toString().split(":");
        if (minutos1 == "03") {
          return;
        }
      }
      if (this.form.id_tipo_permiso == 96 && this.form.hora_desde) {
        let minutos2 = this.form.hora_desde.toString().split(":");
        if (minutos2 == "03") {
          return;
        }
      }
      if (
        parseInt(this.form.id_tipo_permiso) != 96 &&
        parseInt(this.form.id_tipo_permiso) != 88
      ) {
        this.bandera_compensacion = false;
      }

      if (
        parseInt(this.form.id_tipo_permiso) == 96 &&
        this.form.hora_desde &&
        this.form.hora_hasta
      ) {
        this.$bus.$emit("actualizarHoraTolerancia");
      }
      if (
        parseInt(this.form.id_tipo_permiso) == 88 &&
        this.form.fecha_desde &&
        this.form.hora_desde &&
        this.form.hora_hasta &&
        this.bandera_media_hora
      ) {
        try {
          this.form.rol = 4;
          let id_persona = this.getPersonaId();

          await this.$service
            .graphql({
              query: `
              query{
                runQuery(consulta:"select control.fn_corresponde_compensacion(${id_persona},'${this.form.fecha_desde}','${this.form.hora_desde}','${this.form.hora_hasta}')"){
                  respuesta
                }
              }
            `
            })
            .then(async result => {
              if (result) {
                let respuesta =
                  result.runQuery.respuesta[0].fn_corresponde_compensacion;
                respuesta = respuesta.split("|");
                if (respuesta[0] == "SI") {
                  if (bandera_mensaje) {
                    this.$message.info("Usted debe compensar horas");
                  }
                  this.bandera_compensacion = true;
                  this.bandera_8horas = false;

                  let rpta_hora = await this.diferenciaHoras();
                  this.horas_compensacion = this.$moment(
                    rpta_hora,
                    "HH:mm"
                  ).format("HH:mm");
                  // .subtract(this.form.hora_desde, "HH:mm")
                } else if (respuesta[0] == "NO") {
                  this.bandera_compensacion = false;
                  this.horas_compensacion = 0;
                } else {
                  this.bandera_8horas = true;
                  this.horas_compensacion = 0;
                  if (bandera_mensaje) {
                    this.$message.info(respuesta[1]);
                  }
                }
                console.log("------>", respuesta);
                this.$bus.$emit("actualizarHoraTolerancia");
              }
            });
        } catch (error) {
          console.log(error);
        }
      }
    },
    //para permiso trabajo continuo =102
    async calculaHorarioDiscontinuo() {
      try {
        //VALOR ==1
        await pause(2000);
        let año = parseInt(this.fecha_trabajo_continuo.substring(0, 4));
        if (año > 2022) {
        }
        if (this.validarFechas(this.fecha_trabajo_continuo, 1) == false) {
          return;
        }
        let id_persona;
        let user = this.$storage.get("user");
        if (
          this.$route.params.id == null ||
          this.$route.params.id == undefined
        ) {
          id_persona = user.id_persona;
        } else {
          id_persona = parseInt(this.$route.params.id);
        }
        if (this.validarFechas(this.fecha_trabajo_continuo, 2) == false) {
          return;
        }
        let respuesta = await this.$service.graphql({
          query: `
                    query{
                            runQuery(consulta:"SELECT control.fn_obtiene_horarios_salida_entrada(${id_persona}, '${this.fecha_trabajo_continuo}')"){
                              respuesta
                            }
                          }
                        `
        });
        respuesta =
          respuesta.runQuery.respuesta[0].fn_obtiene_horarios_salida_entrada;
        respuesta = respuesta.split("|");
        if (respuesta[0] == "1") {
          this.hora_hasta_trabajo_continuo = respuesta[2];
          this.hora_desde_trabajo_continuo = respuesta[1];
        } else {
          this.$message.info(respuesta[1]);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async diferenciaHoras() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_calcula_diferencia_horas_funcionario(${this.getPersonaId()},'${
            this.form.hora_desde
          }','${this.form.hora_hasta}','${this.form.fecha_desde}')"){
                    respuesta
                  }
                }
              `
        });
        respuesta =
          respuesta.runQuery.respuesta[0]
            .fn_calcula_diferencia_horas_funcionario;
        if (respuesta.split("|")[0] != "0") {
          return respuesta;
        }
        return null;
      } catch (error) {
        console.log(error);
      }
    },
    async calculaDiasHabiles() {
      if (this.form.id_tipo_permiso == 90) {
        await this.obtenerSiguienteFecha();
      }

      let dias = 0;
      let respuesta;
      if (this.form.fecha_desde && this.form.fecha_hasta) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                    query{
                      runQuery(consulta:"select general.fn_cuenta_dias_habiles_por_persona('${
                        this.form.fecha_desde
                      }','${this.form.fecha_hasta}',${parseInt(
              this.getPersonaId()
            )})"){
                        respuesta
                      }
                    }
                  `
          });
          dias =
            respuesta.runQuery.respuesta[0].fn_cuenta_dias_habiles_por_persona;
        } catch (error) {
          console.log(error);
        }
      }
      this.dias_habiles = dias;
    },
    // p18 - Permiso sin goce de haberes
    async getCausalesSinGoce() {
      let consulta = `SELECT * FROM CONTROL.v_subtipo_permiso WHERE id_tipo_permiso = 18`;
      let respuesta = await this.$service.graphql({
        query: `
                  query{
                    runQuery(consulta:"${consulta}"){
                    respuesta
                    }
                    }
                  `
      });
      this.list_causal_permiso_sin_goce = respuesta.runQuery.respuesta;
    },
    getPersonaId() {
      const user = this.$storage.get("user");

      return this.$route.params.id ? this.$route.params.id : user.id_persona;
    },
    getRuta() {
      let p = this.$route.path;
      const a = p.split("/");
      return a[3];
    },
    async crearPermisoCargoVacacion() {
      let id_persona;
      let dato = {};
      dato.rol = 4;
      const fecha = new Date();
      let gestion_vigente = fecha.getFullYear();
      let fecha_permiso = this.$moment(new Date()).format("YYYY-MM-DD");
      let user = this.$storage.get("user");
      try {
        if (
          this.$route.params.id == null ||
          this.$route.params.id == undefined
        ) {
          id_persona = user.id_persona;
        } else {
          id_persona = this.$route.params.id;
        }

        let respuesta = await this.$service.graphql({
          query: `
            query{
                    runQuery(consulta:"select vacaciones.fn_obtiene_saldo_vacacion_por_persona(${id_persona})"){
                    respuesta
                    }
                  }	
  
                `
        });
        let resp =
          respuesta.runQuery.respuesta[0].fn_obtiene_saldo_vacacion_por_persona;
        resp = resp.split("|");
        //obtener el saldo total de vacaciones no programadas
        let resp2;
        let respuesta2 = await this.$service.graphql({
          query: `
            query{
                    runQuery(consulta:"select vacaciones.fn_obtiene_dias_para_cuenta_vacacion(${id_persona},${parseInt(
            gestion_vigente
          )})"){
                    respuesta
                    }
                  }	
                `
        });

        if (
          respuesta2.runQuery.respuesta[0]
            .fn_obtiene_dias_para_cuenta_vacacion == null ||
          !respuesta2.runQuery.respuesta[0].fn_obtiene_dias_para_cuenta_vacacion
        ) {
          this.$message.info(
            `Usted no dispone de dias para programar en la gestión ${gestion_vigente} `
          );
        } else {
          let numero_dias_saldo = respuesta2.runQuery.respuesta[0].fn_obtiene_dias_para_cuenta_vacacion.split(
            "|"
          );
          if (
            numero_dias_saldo[0] == "1" &&
            parseFloat(numero_dias_saldo[1]) < 0.5
          ) {
            this.$message.info(
              `Usted no dispone de dias para programar en la gestión ${gestion_vigente} `
            );
          } else {
            resp2 =
              respuesta2.runQuery.respuesta[0]
                .fn_obtiene_dias_para_cuenta_vacacion;
            let respu = resp2.split("|");
            dato.saldo_no_programadas = parseFloat(respu[1]);
            dato.total_vacaciones = parseFloat(resp[1]);
            this.$bus.$emit("openDialogCrearPermisoCargoVacacion", dato);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    CalcularDias() {
      if (this.form.id_tipo_permiso == 90) {
        // this.limpiarCamposdeFechas()
      } else {
        let fecha_desde = this.$moment(this.form.fecha_desde); //Debe estar en formato YYYY-MM-DD
        let fecha_hasta = this.$moment(this.form.fecha_hasta);
        let dias = 0;
        if (fecha_desde < fecha_hasta) {
          dias = fecha_hasta.diff(fecha_desde, "days"); //Calculamos la diferencia en años
        } else {
          let resp =
            "La fecha de desde no puede ser superior a la fecha hasta.";
        }
        return dias; //retornamos el resultado
      }
    },

    adicionarDetalle() {
      if (this.$refs.form.validate()) {
        const temp = {
          fecha_desde: this.form.fecha_desde,
          fecha_hasta: this.form.fecha_hasta,
          hora_desde: this.form.hora_desde,
          hora_hasta: this.form.hora_hasta,
          index: this.count_id++
        };

        this.permiso_detalles.push(temp);
        this.valid = false;
      }
    },
    eliminarDetalle() {
      if (this.$refs.form.validate()) {
        const temp = {
          fecha_desde: null,
          fecha_hasta: null,
          hora_desde: null,
          hora_hasta: null,
          index: null
        };
        this.permiso_detalles.shift(temp);
        this.valid = true;

        this.$message.success("Detalle Eliminado");
      }
    },
    async obtenerSiguienteFecha() {
      //almacenar en campo motivo el  tipo de baja seleccionado
      let respuesta;
      let dias_de_incapacidad = parseInt(this.form.dias_incapacidad);
      if (this.form.fecha_desde && this.form.dias_incapacidad) {
        var query = ``;
        var tipo_funcion;
        // Preguntamos si es baja medica o censo
        if (this.form.id_tipo_permiso == 90) {
          query = `select control.fn_suma_dias_fecha('${dias_de_incapacidad}','${this.form.fecha_desde}')`;
          tipo_funcion = "fn_suma_dias_fecha";
        } else if (this.form.id_tipo_permiso == 5) {
          // Restamos 1 dia para obtener la fecha correcta
          dias_de_incapacidad--;
          tipo_funcion = "fn_sgte_fecha_habil_funcionario";
          query = `select general.fn_sgte_fecha_habil_funcionario('${
            this.form.fecha_desde
          }',${dias_de_incapacidad},${this.getPersonaId()})`;
        }
        try {
          respuesta = await this.$service.graphql({
            query: `
                  query{
                    runQuery(consulta:"${query}"){
                      respuesta
                    }
                  }
                `
          });
        } catch (error) {
          console.log(error);
        }
        try {
          respuesta = respuesta.runQuery.respuesta[0][tipo_funcion];
          this.fecha_resultante = respuesta
            .split("/")
            .reverse()
            .join("-");

          return this.fecha_resultante;
        } catch (error) {
          console.log(error);
        }
      }
    },

    async obtenerLugarAtencion() {
      try {
        let res = await this.$service.graphql({
          query: `
              query{
              vLugarAtencions{
                rows{
                          id
                          lugar
                          tolerancia_minutos
                    }
                              }
          
                    }
            `
        });
        this.lugar_atencion = res.vLugarAtencions.rows;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerSubpermiso(id_tipo_per) {
      if (id_tipo_per == 44) {
        this.tipo_subpermisos = [
          { id: 1, descripcion: "Cáncer infantil o adolescente" },
          {
            id: 3,
            descripcion:
              "Enfermedades neurológicas que requieren de tratamiento quirúrgico"
          },
          {
            id: 2,
            descripcion: "Enfermedades sistémicas que requieren trasplante"
          },
          { id: 4, descripcion: "Insuficiencia renal crónica" },
          {
            id: 5,
            descripcion:
              "Enfermedades osteoarticulares (huesos y articulaciones) que requieren tratamiento quirúrgico y rehabilitación"
          },
          { id: 6, descripcion: "Discapacidad grave y muy grave" },
          {
            id: 7,
            descripcion:
              "Accidente grave con riesgo de muerte o secuela funcional severa y permanente"
          },
          { id: 8, descripcion: "Accidente grave" }
        ];
      }
    },
    obtenerRolRRHH() {
      try {
        let banderaRRHH = false;
        user.roles.forEach(element => {
          if (element.id == 4) {
            banderaRRHH = true;
          }
        });
        if (banderaRRHH == true) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async obtenerTipoPermiso() {
      let user = this.$storage.get("user");
      this.rol = user.roles[0].id;
      let roles = user.roles;
      let bandera_rrhh = false;
      if (this.$route.params.id) {
        bandera_rrhh = true;
      }
      if (!bandera_rrhh) {
        this.elaborado = 91;
        try {
          let res = await this.$service.graphql({
            query: `
              query {
                              tipoPermisos(id_estado: 19, id_parametro_elaborado:${this.elaborado},restriccion_permiso:"24") {
                  rows {
                    id
                    descripcion
                    refrigerio
                    tiempo_maximo
                    tiempo_minimo
                    aprobado
                    estado {
                      descripcion
                      abrev
                    }
                  }
                }
              }
            `
          });
          let tipo_per = [];
          res.tipoPermisos.rows.forEach(element => {
            if (element.id != 24) {
              tipo_per.push(element);
            }
          });
          this.tipo_permisos = tipo_per;
        } catch (error) {
          console.log(error);
        }
      } else {
        //crea permisos rrhh
        this.elaborado = 92;
        try {
          let resul = await this.$service.graphql({
            query: `
              query{
                    TipoPermisos2(id_estado:19,estado1:91,estado2:92){
                    rows{
                    descripcion
                    id
                    id_parametro_elaborado
                    descripcion
                    refrigerio
                    tiempo_maximo
                    tiempo_minimo
                    aprobado
                    estado {
                      descripcion
                      abrev
                    }
                  }
                }
              }
            `
          });
          this.tipo_permisos = resul.TipoPermisos2.rows;
        } catch (error) {
          console.log(error);
        }
      }
    },
    editarPermisoDetalle(item) {
      this.id_tipo_permi = this.form.id_tipo_permiso;
      this.$bus.$emit("editarDetalle", item, this.id_tipo_permi);
    },
    LimpiaCad(str) {
      let st = str;
      st = st.replaceAll("\\", "\\\\");
      st = st.replaceAll('"', '\\"');
      st = st.replaceAll("'", "");
      return st;
    },

    handleFileUpload() {
      if (this.$refs.file.value !== "") {
        const file = this.$refs.file.files[0];
        if (this.$refs.file.files[0].type.includes("application/pdf")) {
          this.errors.denied = false;
          this.estado_a = 0;
        } else {
          this.errors.denied = true;
          this.estado_a = 1;
        }
        this.file = file;
      }
    },
    handleFileUpload2() {
      if (this.$refs.file.value !== "") {
        const file = this.$refs.file.files[0];

        if (this.$refs.file.value === "") {
          this.errors2.file = true;
        } else {
          this.errors2.file = false;
        }
        if (this.$refs.file.files[0].type.includes("application/pdf")) {
          this.errors2.denied = false;
        } else {
          this.errors2.denied = true;
        }
        this.file = file;
      }
    },
    validarFechas(fecha, valor) {
      try {
        //VALOR=1 VALIDAR FECHAS DE LA INTERFAZ -<2999
        //   VALOR=2 VALIDAR FECHAS PARA GUARDAR >2023 && <2999
        let bandera_fechas = true;
        if (fecha) {
          if (fecha.length > 10) {
            this.$message.info("Año no valido");
            bandera_fechas = false;
            return bandera_fechas;
          }
          let año = parseInt(fecha.substring(0, 4));
          //VALOR ==1
          if (valor == 1 && año > 2022) {
            if (año < 2022 || año > 2999) {
              this.$message.info("Año no valido");
              return;
            }
          }
          //VALOR ==2
          if (valor == 2 && año > 2022) {
            if (año > 2999) {
              this.$message.info("Año no valido");
              bandera_fechas = false;
              return bandera_fechas;
            }
          }
          if (valor == 2 && año < 2023) {
            this.$message.info("Año no valido");
            bandera_fechas = false;
            return bandera_fechas;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async obtenerFechaSalidaYEntrada() {
      try {
        let año;
        let fecha;
        let hora;
        let id_persona = this.getPersonaId();
        let bandera = true;

        if (
          this.form.id_tipo_permiso == 6 &&
          this.form.fecha_fallecimiento &&
          this.form.hora_fallecimiento
        ) {
          año = parseInt(this.form.fecha_fallecimiento.substring(0, 4));

          if (this.validarFechas(this.form.fecha_fallecimiento, 1) == false) {
            this.$message.info("El año no es válido");
            this.form.fecha_fallecimiento = null;
            this.form.hora_fallecimiento = null;
            this.fecha_desde2 = null;
            this.fecha_hasta2 = null;
            bandera = false;
            return;
          }
          if (bandera == true) {
            fecha = this.form.fecha_fallecimiento;
            hora = this.form.hora_fallecimiento;
            bandera = true;
          }
        }
        if (
          this.form.id_tipo_permiso == 61 &&
          this.form.fecha_nacimiento &&
          this.form.hora_nacimiento
        ) {
          año = parseInt(this.form.fecha_nacimiento.substring(0, 4));

          if (this.validarFechas(this.form.fecha_nacimiento, 1) == false) {
            this.$message.info("El año no es válido");
            this.form.fecha_nacimiento = null;
            this.form.hora_nacimiento = null;
            this.fecha_desde2 = null;
            this.fecha_hasta2 = null;
            bandera = false;
          }
          if (bandera == true) {
            fecha = this.form.fecha_nacimiento;
            hora = this.form.hora_nacimiento;
            bandera = true;
          }
        }
        if (this.form.id_tipo_permiso == 12 && this.form.fecha_matrimonio) {
          año = parseInt(this.form.fecha_matrimonio.substring(0, 4));

          if (this.validarFechas(this.form.fecha_matrimonio, 1) == false) {
            this.$message.info("El año no es válido");
            this.form.fecha_nacimiento = null;
            this.form.hora_nacimiento = null;
            this.fecha_desde2 = null;
            this.fecha_hasta2 = null;
            bandera = false;
            return;
          }
          if (bandera == true) {
            fecha = this.form.fecha_matrimonio;
            hora = "00:00";
            bandera = true;
          }
        }
        if (!fecha || fecha == undefined || !hora || hora == undefined) {
          return;
        } else {
          if (bandera) {
            let respuesta = await this.$service.graphql({
              query: `
                  query{
                    runQuery(consulta:"select control.fn_obtiene_fechas_licencia(${parseInt(
                      this.form.id_tipo_permiso
                    )},${id_persona},'${fecha}','${hora}')"){
                    respuesta
                    }
                  }	
  
                `
            });
            let resp =
              respuesta.runQuery.respuesta[0].fn_obtiene_fechas_licencia;
            resp = resp.split("|");
            console.log(resp);
            this.fecha_desde2 = resp[0];
            this.fecha_hasta2 = resp[1];
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async verificarPermisosRango(
      fecha_desde,
      fecha_hasta,
      hora_desde,
      hora_hasta
    ) {
      //Funcion notifica que hay un permiso creado en el rango de fechas seleccionado
      // control.fn_muestra_permisos_funcionario(p_id_persona integer, p_fecha date, p_fecha_hasta date,hora_desde varchar, hora_hasta varchar)
      let existePermisos = false;
      let permisos = "¿Esta seguro guardar el permiso?";
      let permisos_consulta = "";
      let respuesta;
      try {
        console.log('verificarPermisosRangO rrhh....',this.getPersonaId(),fecha_desde,fecha_hasta,hora_desde,hora_hasta);
        respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_permisos_por_funcionario(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}','${hora_desde}','${hora_hasta}')"){
                    respuesta
                  }
                }
              `
        });
        
        respuesta = respuesta.runQuery.respuesta[0].fn_permisos_por_funcionario;
        console.log('respuesta rrhh....',respuesta);
        respuesta = respuesta.split("|");
        
        
        if (respuesta[0] == "1") {
          existePermisos = true;
          permisos_consulta +=
            "<br><strong>Usted tiene los siguientes permisos en las fechas u horarios solicitados:</strong><br>" +
            respuesta[1].replace(/#/g, "<br>");
        }
      } catch (error) {
        console.log(error);
      }

      if (existePermisos) {
        this.$alert(
          "No puede crear el permiso" + permisos_consulta,
          "-",
          "Aviso"
        );
      }
      return [existePermisos, permisos + permisos_consulta];
    },
    redireccionarUrl() {
      if (this.getRuta() != this.getPersonaId()) {
        this.$router.push("/permisos/usuario");
      }
      if (this.getRuta() == this.getPersonaId()) {
        this.$router.push("/permisos/usuario/" + this.getPersonaId());
      }
    },
    async obtenerHorarioPersona(id_persona, id_radio_data, fecha) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select control.fn_rango_horario_por_persona_solo_horarios (${parseInt(
                  id_persona
                )},${parseInt(id_radio_data)},'${fecha}')"){
                  respuesta
                }
              }
            `
        });
        if (
          respuesta.runQuery.respuesta[0]
            .fn_rango_horario_por_persona_solo_horarios != null
        ) {
          respuesta = respuesta.runQuery.respuesta[0].fn_rango_horario_por_persona_solo_horarios.split(
            "|"
          );

          if (respuesta[0] != "0") {
            return [respuesta[0], respuesta[1]];
          } else {
            return "No";
          }
        } else {
          this.$message.warning(
            "Sin horario asignado para la fecha del permiso"
          );
        }
      } catch (error) {
        console.log(error);
      }
    },

    validarFechasFinales() {
      let validacion_fechas;
      //validando fechas:

      let bandera_fechas = true;
      let tipo_permiso = parseInt(this.form.id_tipo_permiso);
      switch (tipo_permiso) {
        case 61: //LICENCIA POR PATERNIDAD
          validacion_fechas = this.validarFechas(this.form.fecha_nacimiento, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 6: //LICENCIA POR DUELO
          validacion_fechas = this.validarFechas(
            this.form.fecha_fallecimiento,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 12: //LICENCIA POR MATRIMONIO
          validacion_fechas = this.validarFechas(this.form.fecha_matrimonio, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 102: //TRABAJO CONTINUO
          validacion_fechas = this.validarFechas(
            this.fecha_trabajo_continuo,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 101: //ASUETO
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 100: //ASUETO DIA DE LA MUJER
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 99: //ASUETO DIA DE LA MADRE
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 98: //ASUETO DIA DEL PADRE
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 96: //TOLERANCIA
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          console.log("hfhfhf", this.form.fecha_desde);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 94: //FORMULARIO DE OMISIÓN DE REGISTRO DE ASISTENCIA
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 89: //ASUETO POR CUMPLEAÑOS
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 88: //PERMISO PERSONAL CON GOCE DE HABERES
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 87: //PERMISO OFICIAL POR HORAS
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 103: //COMISION DE SERVICIO
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 14: // LICENCIA PERSONAL DS 25749
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
          case 105: // LICENCIA QUE LA ENTIDAD OTORGUE
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 38: // TOLERANCIA MAMOGRAFIA (798-252)
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 41: // TOLERANCIA EXÁMENES COMPLEMENTARIOS (798-252)
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 42: // TOLERANCIA EXÁMEN FÍSICO DE PRÓSTATA (798-252)
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 43: // TOLERANCIA EXÁMEN DE LABORATORIO (PSA)(798-252)
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 37: // TOLERANCIA MAMA Y PAPANICOLAOU (798-252)
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 40: // TOLERANCIA COLON (ANAMNESIS Y EXÁMEN FÍSICO 798-252)
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 8: // JUSTIFICATIVO CAJA
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;

        case 90: // BAJA MÉDICA
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 5: // CENSO
          validacion_fechas = this.validarFechas(this.form.fecha_desde, 2);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        default:
          console.log(`Fecha no valida`);
      }
      return bandera_fechas;
    },
    async save() {
      //validando fecha
      if (this.validarFechasFinales() == false) {
        //id_persona
        return;
      }

      await pause(2000);
      await this.verificarCompensacion(true);

      if (
        this.form.id_tipo_permiso == 88 &&
        this.bandera_compensacion == true
      ) {
        this.$message.info("Usted debe compensar horas");
        return;
      }
      if (this.form.id_tipo_permiso == 88 && this.bandera_8horas == true) {
        this.$message.info("Las horas del permiso deben ser de media hora");
        return;
      }
      if (this.$refs.form.validate()) {
        let existe_error_guardar = true;
        this.loading_boton = true;
        let correcto;
        this.loading = true;
        let valor_tiempo;
        let fecha = this.$moment(new Date()).format("YYYY-MM-DD");
        let resps = [];

        // Documento no obligatorio, solo valida el tipo SOLO PDF

        if (
          this.file &&
          (this.form.id_tipo_permiso == 87 || this.form.id_tipo_permiso == 96)
        ) {
          if (this.errors.denied) {
            this.loading_boton = false;
            this.loading_boton = false;
            return this.errors;
          }
        }

        // Documentos obligatorios, y de tipo PDF
        if (
          this.form.id_tipo_permiso == 6 ||
          this.form.id_tipo_permiso == 61 ||
          this.form.id_tipo_permiso == 95 ||
          this.form.id_tipo_permiso == 44 ||
          this.form.id_tipo_permiso == 18 ||
          this.form.id_tipo_permiso == 103 ||
          this.form.id_tipo_permiso == 90 ||
          this.form.id_tipo_permiso == 12 ||
          this.form.id_tipo_permiso == 8 ||
          this.form.id_tipo_permiso == 5 ||
          (this.form.id_tipo_permiso >= 37 && this.form.id_tipo_permiso <= 43)
        ) {
          if (this.$refs.file.value === "") {
            this.errors2.file = true;
            this.loading_boton = false;
            return this.errors2;
          } else {
            this.errors2.file = false;
          }

          if (this.errors2.denied) {
            this.loading_boton = false;
            return this.errors2;
          }
        }

        if (
          this.file != "" &&
          (this.form.id_tipo_permiso == 14 ||
          this.form.id_tipo_permiso == 105 ||
            this.form.id_tipo_permiso == 87 ||
            this.form.id_tipo_permiso == 103 ||
            this.form.id_tipo_permiso == 61 ||
            this.form.id_tipo_permiso == 95 ||
            this.form.id_tipo_permiso == 96 ||
            this.form.id_tipo_permiso == 6 ||
            this.form.id_tipo_permiso == 90 ||
            this.form.id_tipo_permiso == 44 ||
            this.form.id_tipo_permiso == 18 ||
            this.form.id_tipo_permiso == 12 ||
            this.form.id_tipo_permiso == 8 ||
            this.form.id_tipo_permiso == 5 ||
            (this.form.id_tipo_permiso >= 37 &&
              this.form.id_tipo_permiso <= 43))
        ) {
          let formData = new FormData();
          formData.append("file", this.file);
          let res = await this.$http.post(
            process.env.API_URL + "public/upload",
            formData
          );
          this.form.ruta_archivo = res.data;
        } else {
          if (
            this.form.id_tipo_permiso == 14 ||
            this.form.id_tipo_permiso == 105 ||
            this.form.id_tipo_permiso == 87 ||
            this.form.id_tipo_permiso == 90 ||
            this.form.id_tipo_permiso == 61 ||
            this.form.id_tipo_permiso == 6 ||
            this.form.id_tipo_permiso == 12 ||
            this.form.id_tipo_permiso == 8 ||
            this.form.id_tipo_permiso == 95 ||
            this.form.id_tipo_permiso == 96 ||
            (this.form.id_tipo_permiso >= 37 && this.form.id_tipo_permiso <= 43)
          ) {
            this.form.ruta_archivo = "";
          }
        }
        correcto = true;
        let respuesta;
        let user = this.$storage.get("user");
        let id_persona = this.getPersonaId();

        let id = user.id;
        let motivo = this.form.motivo;
        let lugar = this.form.lugar;
        let ruta_archivo = this.form.ruta_archivo;

        if (this.form.id_tipo_permiso == 96) {
          this.form.fecha_hasta = this.form.fecha_desde;
          lugar = null;
        }
        if (
          this.form.id_tipo_permiso == 13 ||
          this.form.id_tipo_permiso == 15
        ) {
          fecha = this.form.fecha_desde;
          this.form.hora_desde = this.tiempos_radio[this.radio_data].hora_desde;
          this.form.hora_hasta = this.tiempos_radio[this.radio_data].hora_hasta;
          //this.form.hora_desde = this.radio_data.turno;
        }
        if (this.form.id_tipo_permiso == 95) {
          this.form.hora_desde = "08:30";
          this.form.hora_hasta = "16:30";
        }

        // if (this.form.id_tipo_permiso==87) {
        //   this.form.fecha_hasta = this.form.fecha_desde;
        //   motivo = this.LimpiaCad(motivo);
        //   lugar = this.LimpiaCad(lugar);
        // } else {
        //   (motivo = null), (lugar = null);
        // }
        if (
          this.form.id_tipo_permiso == 12 ||
          this.form.id_tipo_permiso == 6 ||
          this.form.id_tipo_permiso == 61
        ) {
          lugar = null;
          motivo = null;
          let hora_de = "08:30";
          let hora_ha = "16:30";
          this.form.hora_desde = hora_de;
          this.form.hora_hasta = hora_ha;
        }
        if (
          this.form.id_tipo_permiso == 13 ||
          this.form.id_tipo_permiso == 15
        ) {
          this.form.fecha_hasta = this.form.fecha_desde;
          lugar = null;
          motivo = null;
          this.form.hora_desde = this.tiempos_radio[this.radio_data].hora_desde;
          this.form.hora_hasta = this.tiempos_radio[this.radio_data].hora_hasta;
        }
        if (
          this.form.id_tipo_permiso >= 37 &&
          this.form.id_tipo_permiso <= 43
        ) {
          if (this.radio_data == "toda-mañana") {
            valor_tiempo = 1;
          } else {
            valor_tiempo = 2;
          }
          this.form.hora_desde = this.tiempos_radio[this.radio_data].hora_desde;
          this.form.hora_hasta = this.tiempos_radio[this.radio_data].hora_hasta;
          this.form.fecha_hasta = this.form.fecha_desde;
        }
        if (
          this.form.id_tipo_permiso == 17 ||
          this.form.id_tipo_permiso == 16 ||
          this.form.id_tipo_permiso == 18 ||
          this.form.id_tipo_permiso == 24
        ) {
          this.form.hora_desde = "";
          this.form.hora_hasta = "";
        }
        if (this.form.id_tipo_permiso == 90) {
          motivo = this.form.tipo_baja;
        }
        if (this.form.id_tipo_permiso == 94) {
          if (!this.form.tipo_dia) {
            this.form.tipo_dia = null;
          }
          if (!this.form.tipo_horario) {
            this.form.tipo_horario = null;
          }
          motivo = this.tipo_dia;
          this.form.hora_hasta = this.hora_calculada;
          this.form.tipo_baja = "";
          ruta_archivo = "";
        }
        if (this.form.id_tipo_permiso == 88 || this.form.id_tipo_permiso == 8) {
          this.form.fecha_hasta = this.form.fecha_desde;
          lugar = "";
          motivo = "";
        }

        let permiso = {
          id_tipo_permiso: parseInt(this.form.id_tipo_permiso),
          motivo: motivo,

          id_persona: id_persona,
          id_funcionario: id,
          fecha_permiso: fecha,
          lugar: lugar,
          ruta_archivo: ruta_archivo,
          id_lugar: this.form.id
        };

        let permiso_detalle = {
          fecha_desde: this.form.fecha_desde,
          fecha_hasta: this.form.fecha_hasta,
          hora_desde: this.form.hora_desde,
          hora_hasta: this.form.hora_hasta
        };

        if (this.form.id_tipo_permiso == 44) {
          let verifica_vacacion = await this.verificaVacaciones(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_hasta
          );
          if (verifica_vacacion == true) {
            this.loading_boton = false;
            return;
          }
          let consulta = await this.verificarPermisosRango(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_hasta,
            "",
            ""
          );
          if (consulta[0] == true) {
            this.loading_boton = false;
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              respuesta = await this.$service.graphql({
                query: `
                                query{
                                  runQuery(consulta:"select control.fn_registra_ds3462  (${
                                    permiso.id_tipo_permiso
                                  },${permiso.id_persona},'${
                  permiso.fecha_permiso
                }',${permiso.id_funcionario},'${
                  permiso_detalle.fecha_desde
                }','${permiso_detalle.fecha_hasta}','${
                  this.form.ruta_archivo
                }',${parseInt(this.form.id_tipo_subpermiso)})"){
                                    respuesta
                                  }
                                }
                              `
              });
            } catch (error) {
              console.log(error);
            }
            try {
              respuesta = respuesta.runQuery.respuesta[0].fn_registra_ds3462;
              resps = respuesta.split("|");
              correcto = resps[0];

              if (correcto === "1") {
                this.$confirm("Registro exitoso", () => {});
                this.redireccionarUrl();
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        if (this.form.id_tipo_permiso == 87) {
          console.log("entra a 3161");
          //permiso oficial por horas
          //consulta si existe un vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_desde
          );
          if (verifica_vacacion == true) {
            this.loading_boton = false;
            return;
          }
           //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_desde,
            permiso_detalle.hora_desde,
            permiso_detalle.hora_hasta
          );
          if (consulta[0] == true) {
            this.loading_boton = false;
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              permiso.motivo = permiso.motivo.replace(/(\r\n|\n|\r)/gm, " ");
              permiso.motivo = permiso.motivo.replace(/"/g, "`");
              let respuesta = await this.$service.graphql({
                query: `
                      query{
                        runQuery(consulta:"select control.fn_registra_permiso_archivo(${permiso.id_tipo_permiso},'${permiso.motivo}',${permiso.id_persona},'${permiso.fecha_permiso}',${permiso.id_funcionario}, '${permiso.lugar}','${permiso_detalle.fecha_desde}','${permiso_detalle.fecha_desde}','${permiso_detalle.hora_desde}','${permiso_detalle.hora_hasta}','${permiso.ruta_archivo}',4)"){
                          respuesta
                        }
                      }
                    `
              });
              respuesta =
                respuesta.runQuery.respuesta[0].fn_registra_permiso_archivo;

              resps = respuesta.split("|");
              correcto = resps[0];

              if (correcto === "1") {
                this.$confirm("Registro exitoso", () => {});
                this.redireccionarUrl();
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
          return;
        }
        //  permiso comision de servicios:
        if (this.form.id_tipo_permiso == 103) {
          //consulta si existe un vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_hasta
          );
          if (verifica_vacacion == true) {
            this.loading_boton = false;
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_hasta,
            permiso_detalle.hora_desde,
            permiso_detalle.hora_hasta
          );
          if (consulta[0] == true) {
            this.loading_boton = false;
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              permiso.motivo = permiso.motivo.replace(/(\r\n|\n|\r)/gm, " ");
              permiso.motivo = permiso.motivo.replace(/"/g, "`");

              respuesta = await this.$service.graphql({
                query: `
                      query{
                        runQuery(consulta:"select control.fn_registra_comision_servicio(${parseInt(
                          permiso.id_persona
                        )},'${permiso.motivo}','${
                  permiso_detalle.fecha_desde
                }','${permiso_detalle.fecha_hasta}','${permiso.lugar}','${
                  permiso_detalle.hora_desde
                }','${permiso_detalle.hora_hasta}','${
                  permiso.ruta_archivo
                }',${parseInt(permiso.id_funcionario)},4)"){
                          respuesta
                        }
                      }
                    `
              });
            } catch (error) {
              console.log(error);
            }
            try {
              respuesta =
                respuesta.runQuery.respuesta[0].fn_registra_comision_servicio;

              resps = respuesta.split("|");
              correcto = resps[0];

              if (correcto === "1") {
                this.$confirm("Registro exitoso", () => {});
                this.redireccionarUrl();
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }


        if (this.form.id_tipo_permiso == 88) {
          this.loading_boton = false;
          //consulta si existe un vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_hasta
          );
          console.log('verifica_vacacion',verifica_vacacion);
          if (verifica_vacacion == true) {
            this.loading_boton = false;
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          console.log(permiso_detalle.fecha_desde, permiso_detalle.fecha_hasta,permiso_detalle.hora_desde, permiso_detalle.hora_hasta);
          let consulta = await this.verificarPermisosRango(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_hasta,
            permiso_detalle.hora_desde,
            permiso_detalle.hora_hasta
          );
      
          console.log('verificarPermisosRango',consulta);
          if (consulta[0] == true) {
            this.loading_boton = false;
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              // Volvemos a validar compensaciones
              console.log('validacion correcta');
              await this.verificarCompensacion(true);
              if (this.bandera_compensacion) {
                this.loading_boton = false;
                return;
              }
              permiso.motivo = permiso.motivo.replace(/(\r\n|\n|\r)/gm, " ");
              permiso.motivo = permiso.motivo.replace(/"/g, "`");
              respuesta = await this.$service.graphql({
                query: `
                    query{
                        runQuery(consulta:"select control.fn_registra_permiso_particular(${permiso.id_tipo_permiso},'${permiso.motivo}',${permiso.id_persona},'${permiso.fecha_permiso}',${permiso.id_funcionario}, '${permiso.lugar}','${permiso_detalle.fecha_desde}','${permiso_detalle.fecha_hasta}','${permiso_detalle.hora_desde}','${permiso_detalle.hora_hasta}',4)"){
                            respuesta
                        }
                      }
                    `
              });
              let respuesta2 =
                respuesta.runQuery.respuesta[0].fn_registra_permiso_particular;
              resps = respuesta2.split("|");
              correcto = resps[0];

              if (correcto === "1") {
                this.$confirm("Registro exitoso", () => {});
                this.redireccionarUrl();
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }

        if (this.form.id_tipo_permiso == 12) {
          if (this.validarFechasFinales() == false) {
            return;
          }
          if (
            !this.fecha_desde2 ||
            !this.fecha_hasta2 ||
            !this.form.fecha_matrimonio
          ) {
            this.$message.info("Fecha no valida");
            return;
          }
          //consulta si existe un vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            this.fecha_desde2,
            this.fecha_hasta2
          );
          if (verifica_vacacion == true) {
            this.loading_boton = false;
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            this.fecha_desde2,
            this.fecha_hasta2,
            "",
            ""
          );
          if (consulta[0] == true) {
            this.loading_boton = false;
            return;
          }

          this.$confirm(consulta[1], async () => {
            try {
              respuesta = await this.$service.graphql({
                query: `
                  query{
                      runQuery(consulta:"select control.fn_registra_permiso_matrimonio(${this.form.id_tipo_permiso},${permiso.id_persona},'${this.form.fecha_matrimonio}', '${this.fecha_desde2}','${this.fecha_hasta2}',${permiso.id_funcionario},'${permiso.ruta_archivo}',4)"){
                      respuesta
                      }
                    }
                  `
              });
            } catch (error) {
              console.log(error);
            }
            try {
              respuesta =
                respuesta.runQuery.respuesta[0].fn_registra_permiso_matrimonio;

              let resps = respuesta.split("|");
              let correcto = resps[0];
              if (correcto === "1") {
                this.$confirm("Registro exitoso", () => {});
                this.redireccionarUrl();
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        //permiso trabajo continuo=102
        if (this.form.id_tipo_permiso == 102) {
          //consulta si existe un vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            this.fecha_trabajo_continuo,
            this.fecha_trabajo_continuo
          );
          if (verifica_vacacion == true) {
            this.loading_boton = false;
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            this.fecha_trabajo_continuo,
            this.fecha_trabajo_continuo,
            this.hora_desde_trabajo_continuo,
            this.hora_hasta_trabajo_continuo
          );
          if (consulta[0] == true) {
            this.loading_boton = false;
            return;
          }
          let user_permiso = this.$storage.get("user");
          this.$confirm(consulta[1], async () => {
            try {
              respuesta = await this.$service.graphql({
                query: `
                  query{
                      runQuery(consulta:"SELECT control.fn_registra_permiso_trabajo_continuo(${permiso.id_persona},'${this.fecha_trabajo_continuo}', '${this.hora_desde_trabajo_continuo}','${this.hora_hasta_trabajo_continuo}','${this.form.motivo}',${user_permiso.id},4)"){
                      respuesta
                      }
                    }
                  `
              });
            } catch (error) {
              console.log(error);
            }
            try {
              respuesta =
                respuesta.runQuery.respuesta[0]
                  .fn_registra_permiso_trabajo_continuo;

              let resps = respuesta.split("|");
              let correcto = resps[0];
              if (correcto === "1") {
                this.$confirm("Registro exitoso", () => {});
                this.redireccionarUrl();
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        if (this.form.id_tipo_permiso == 95) {
          //consulta si existe un vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_hasta
          );
          if (verifica_vacacion == true) {
            this.loading_boton = false;
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_hasta,
            permiso_detalle.hora_desde,
            permiso_detalle.hora_hasta
          );
          if (consulta[0] == true) {
            this.loading_boton = false;
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              // permiso.motivo = permiso.motivo.replace(/(\r\n|\n|\r)/gm, " ");
              // permiso.motivo = permiso.motivo.replace(/"/g, "`");
              respuesta = await this.$service.graphql({
                query: `
                        query{
                          runQuery(consulta:"select control.fn_registra_permiso_teletrabajo(${permiso.id_tipo_permiso},'',${permiso.id_persona},'${permiso.fecha_permiso}',${permiso.id_funcionario}, '${permiso.lugar}','${permiso_detalle.fecha_desde}','${permiso_detalle.fecha_hasta}','${permiso_detalle.hora_desde}','${permiso_detalle.hora_hasta}','${permiso.ruta_archivo}')"){
                            respuesta
                        }
                      }
                    `
              });
            } catch (error) {
              console.log(error);
            }
            try {
              respuesta =
                respuesta.runQuery.respuesta[0].fn_registra_permiso_teletrabajo;
              resps = respuesta.split("|");
              correcto = resps[0];

              if (correcto === "1") {
                this.$alert("Se creo correctamente el permiso", "-", "Aviso");
                this.redireccionarUrl();
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        // Asueto dia la mujer p100 p99 p98 p89
        if (
          this.form.id_tipo_permiso == 89 ||
          this.form.id_tipo_permiso == 98 ||
          this.form.id_tipo_permiso == 99 ||
          this.form.id_tipo_permiso == 100
        ) {
          // Validando si existe otros permisos en el mismo rango de fechas y horas
          let hora_desde, hora_hasta;
          if (this.radio_data) {
            hora_desde = "";
            hora_hasta = "";
            [hora_desde, hora_hasta] = await this.obtenerHorarioPersona(
              permiso.id_persona,
              this.radio_data,
              permiso.fecha_permiso
            );
          }
          if (
            (await this.obtenerHorarioPersona(
              permiso.id_persona,
              this.radio_data,
              permiso.fecha_permiso
            )) != "No"
          ) {
            //consulta si existe un vacacion aprobada en ese rango de fechas
            let verifica_vacacion = await this.verificaVacaciones(
              permiso_detalle.fecha_desde,
              permiso_detalle.fecha_desde
            );
            if (verifica_vacacion == true) {
              this.loading_boton = false;
              return;
            }
            //consulta si existe un permiso aprobado en ese rango de fechas
            let consulta = await this.verificarPermisosRango(
              permiso_detalle.fecha_desde,
              permiso_detalle.fecha_desde,
              hora_desde,
              hora_hasta
            );
            if (consulta[0] == true) {
              this.loading_boton = false;
              return;
            }
            this.$confirm(consulta[1], async () => {
              try {
                respuesta = await this.$service.graphql({
                  query: `
                  query{
                      runQuery(consulta:"select control.fn_registra_permiso_asueto('${permiso.fecha_permiso}','${permiso_detalle.fecha_desde}',${permiso.id_tipo_permiso},${permiso.id_funcionario},${permiso.id_persona},${this.radio_data},4)"){
                        respuesta
                      }
                    }
                  `
                });
              } catch (error) {
                console.log(error);
              }
              try {
                respuesta =
                  respuesta.runQuery.respuesta[0].fn_registra_permiso_asueto;
                let resps = respuesta.split("|");
                let correcto = resps[0];
                if (correcto === "1") {
                  this.$confirm("Registro exitoso " + resps, () => {});
                  this.redireccionarUrl();
                } else {
                  this.$confirm(resps[1], () => {});
                }
              } catch (error) {
                console.log(error);
              }
            });
          } else {
            this.$confirm("Funcionario sin horario laboral definido", () => {});
          }
        }

        // Asueto otros p101
        if (this.form.id_tipo_permiso == 101) {
          // Validando si existe otros permisos en el mismo rango de fechas y horas
          let hora_desde, hora_hasta;
          if (this.radio_data) {
            hora_desde = "";
            hora_hasta = "";
            [hora_desde, hora_hasta] = await this.obtenerHorarioPersona(
              permiso.id_persona,
              this.radio_data,
              permiso.fecha_permiso
            );
          }
          if (
            (await this.obtenerHorarioPersona(
              permiso.id_persona,
              this.radio_data,
              permiso.fecha_permiso
            )) != "No"
          ) {
            //consulta si existe un vacacion aprobada en ese rango de fechas
            let verifica_vacacion = await this.verificaVacaciones(
              this.form.fecha_desde,
              this.form.fecha_desde
            );
            if (verifica_vacacion == true) {
              this.loading_boton = false;
              return;
            }
            //consulta si existe un permiso aprobado en ese rango de fechas
            let consulta = await this.verificarPermisosRango(
              this.form.fecha_desde,
              this.form.fecha_desde,
              hora_desde,
              hora_hasta
            );
            if (consulta[0] == true) {
              this.loading_boton = false;
              return;
            }
            this.$confirm(consulta[1], async () => {
              // SELECT control.fn_registra_permiso_asueto_otros(
              //   p_fecha_actual date,
              //   p_fecha_asueto date,
              //   p_id_tipo_permiso integer,
              //   p_id_funcionario integer,
              //   p_id_persona integer,
              //   p_bandera integer,
              //   p_motivo CHARACTER VARYING)
              try {
                respuesta = await this.$service.graphql({
                  query: `
                  query{
                      runQuery(consulta:"select control.fn_registra_permiso_asueto_otros('${permiso.fecha_permiso}','${this.form.fecha_desde}',${permiso.id_tipo_permiso},${permiso.id_funcionario},${permiso.id_persona},${this.radio_data},'${this.form.motivo}')"){
                        respuesta
                      }
                    }
                  `
                });
              } catch (error) {
                console.log(error);
              }
              try {
                respuesta =
                  respuesta.runQuery.respuesta[0]
                    .fn_registra_permiso_asueto_otros;
                let resps = respuesta.split("|");
                let correcto = resps[0];
                if (correcto === "1") {
                  this.$confirm("Registro exitoso " + resps, () => {});
                  this.redireccionarUrl();
                } else {
                  this.$confirm(resps[1], () => {});
                }
              } catch (error) {
                console.log(error);
              }
            });
          } else {
            this.$confirm("Funcionario sin horario laboral definido", () => {});
          }
        }

        if (this.form.id_tipo_permiso == 8) {
          //validando que se haya cargado el archivo:
          if (!permiso.ruta_archivo || permiso.ruta_archivo == null) {
            this.$message.info("Debe adjuntar la baja médica");
            return;
          }
          //consulta si existe un vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_hasta
          );
          if (verifica_vacacion == true) {
            this.loading_boton = false;
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_hasta,
            permiso_detalle.hora_desde,
            permiso_detalle.hora_hasta
          );
          if (consulta[0] == true) {
            this.loading_boton = false;
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              console.log("riuta: ", permiso.ruta_archivo);
              respuesta = await this.$service.graphql({
                query: `
                        query{
                          runQuery(consulta:"select control.fn_reg_permiso_caja(${permiso.id_tipo_permiso},${permiso.id_persona},'${permiso.fecha_permiso}',${permiso.id_funcionario}, '${permiso.lugar}','${permiso_detalle.fecha_desde}','${permiso_detalle.fecha_hasta}','${permiso_detalle.hora_desde}','${permiso_detalle.hora_hasta}',1,'${permiso.ruta_archivo}',4)"){
                            respuesta
                          }
                        }
                      `
              });
            } catch (error) {
              console.log(error);
            }
            try {
              respuesta = respuesta.runQuery.respuesta[0].fn_reg_permiso_caja;
              // resps = respuesta.split('|');
              // correcto = resps[0] == 1;
              let resps = respuesta.split("|");
              let correcto = resps[0];

              if (correcto === "1") {
                this.$confirm("Registro exitoso  ", () => {});
                this.redireccionarUrl();
              } else {
                this.$confirm(resps[1], () => {});
                // this.close()
              }
            } catch (error) {
              console.log(error);
            }
          });
        }

        if (this.form.id_tipo_permiso == 14) { //R-0922
          // Validando si existe otros permisos en el mismo rango de fechas y horas
          let hora_desde, hora_hasta;
          if (
            this.radio_data == 0 ||
            this.radio_data == 1 ||
            this.radio_data == 2
          ) {
            hora_desde = "";
            hora_hasta = "";
            [hora_desde, hora_hasta] = await this.obtenerHorarioPersona(
              permiso.id_persona,
              this.radio_data,
              permiso.fecha_permiso
            );
          }
          if (
            (await this.obtenerHorarioPersona(
              permiso.id_persona,
              this.radio_data,
              permiso.fecha_permiso
            )) != "No"
          ) {
            //consulta si existe una vacacion aprobada en ese rango de fechas
            let verifica_vacacion = await this.verificaVacaciones(
              permiso_detalle.fecha_desde,
              permiso_detalle.fecha_desde
            );
            if (verifica_vacacion == true) {
              this.loading_boton = false;
              return;
            }
            //consulta si existe un permiso aprobado en ese rango de fechas
            let consulta = await this.verificarPermisosRango(
              permiso_detalle.fecha_desde,
              permiso_detalle.fecha_desde,
              hora_desde,
              hora_hasta
            );
            if (consulta[0] == true) {
              this.loading_boton = false;
              return;
            }
            this.$confirm(consulta[1], async () => {
              try {
                let respuesta = await this.$service.graphql({
                  query: `
                          query{
                              runQuery(consulta:"select control.fn_registra_lic_personal(${permiso.id_persona},'${permiso.fecha_permiso}',${permiso.id_funcionario}, '${permiso_detalle.fecha_desde}','${permiso_detalle.fecha_desde}',${this.radio_data},4)"){
                              respuesta
                              }
                            }
                          `
                });
              
                respuesta =
                  respuesta.runQuery.respuesta[0].fn_registra_lic_personal;

                let resps = respuesta.split("|");
                let correcto = resps[0];
                if (correcto == "1") {
                  this.$confirm("Registro exitoso  ", () => {});
                  this.redireccionarUrl();
                } else {
                  this.$confirm(resps[1], () => {});
                }
              } catch (error) {
                console.log(error);
              }
            });
            return;
          } else {
            this.$confirm("Funcionario sin horario laboral definido", () => {});
          }
        }


        if (this.form.id_tipo_permiso == 105) {
          // Validando si existe otros permisos en el mismo rango de fechas y horas
          let verifica_vacacion = await this.verificaVacaciones(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_hasta
          );
          if (verifica_vacacion == true) {
            this.loading_boton = false;
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_hasta,
            permiso_detalle.hora_desde,
            permiso_detalle.hora_hasta
          );
          if (consulta[0] == true) {
            this.loading_boton = false;
            return;
          }



            this.$confirm(consulta[1], async () => {
              try {
                console.log(`
                            query{
                              runQuery(consulta:"select control.fn_registra_lic_entidad_otorgue(${permiso.id_persona},'${permiso.fecha_permiso}',${permiso.id_funcionario}, '${permiso_detalle.fecha_desde}','${permiso_detalle.fecha_hasta}',0,4, '${permiso.motivo}' )"){
                              respuesta
                              }
                            }
                          `);
                respuesta = await this.$service.graphql({
                  query: `
                            query{
                              runQuery(consulta:"select control.fn_registra_lic_entidad_otorgue(${permiso.id_persona},'${permiso.fecha_permiso}',${permiso.id_funcionario}, '${permiso_detalle.fecha_desde}','${permiso_detalle.fecha_hasta}',0,4, '${permiso.motivo}')"){
                              respuesta
                              }
                            }
                          `
                });
              } catch (error) {
                console.log(error);
              }
              try {
                console.log(
                  respuesta.runQuery.respuesta[0].fn_registra_lic_entidad_otorgue
                );
                respuesta =
                  respuesta.runQuery.respuesta[0].fn_registra_lic_entidad_otorgue;

                let resps = respuesta.split("|");
                let correcto = resps[0];
                if (correcto == "1") {
                  this.$confirm("Registro exitoso  ", () => {});
                  this.redireccionarUrl();
                } else {
                  this.$confirm(resps[1], () => {});
                }
              } catch (error) {
                console.log(error);
              }
            });
          } 
        




        if (this.form.id_tipo_permiso == 94) {
          let id_permiso_omision = null;
          if (this.form.id_tipo_omision == 1) {
            id_permiso_omision = null;
            this.form.tipo_horario = null;
          }
          if (this.form.id_tipo_omision == 2) {
            id_permiso_omision = parseInt(
              this.form.id_permiso_omision.id_permiso
            );
          }
          if (this.form.id_tipo_omision == 3) {
            id_permiso_omision = parseInt(
              this.form.id_compensacion_omision.id_permiso
            );
          }
          let res;
          try {
            // permiso.motivo = permiso.motivo.replace(/(\r\n|\n|\r)/gm, " ");
            // permiso.motivo = permiso.motivo.replace(/"/g, "`");
            res = await this.$service.graphql({
              query: `
                        query{
                          runQuery(consulta:"select control.fn_registra_formulario_asistencia(${permiso.id_tipo_permiso},'',${permiso.id_persona},'${permiso.fecha_permiso}',${permiso.id_funcionario}, '${permiso.lugar}','${permiso_detalle.fecha_desde}','${permiso_detalle.fecha_desde}','${this.hora_calculada}','${this.hora_calculada}','${permiso.ruta_archivo}',4,${id_permiso_omision},${this.form.tipo_horario})"){
                            respuesta
                          }
                        }
                      `
            });
          } catch (error) {
            console.log(error);
          }
          try {
            respuesta =
              res.runQuery.respuesta[0].fn_registra_formulario_asistencia;
            resps = respuesta.split("|");
            correcto = resps[0];
            if (correcto === "1") {
              this.$confirm("Registro exitoso  ", () => {});
              this.redireccionarUrl();
            } else {
              this.$confirm(resps[1], () => {});
            }
          } catch (error) {
            console.log(error);
            this.$message.error(resps);
          }
        }
        // Permiso censo
        if (this.form.id_tipo_permiso == 5) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permiso_detalle.fecha_desde,
            this.fecha_resultante
          );
          if (verifica_vacacion == true) {
            this.loading_boton = false;
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permiso_detalle.fecha_desde,
            this.fecha_resultante,
            "",
            ""
          );
          if (consulta[0] == true) {
            this.loading_boton = false;
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              respuesta = await this.$service.graphql({
                query: `
                    query{
                      runQuery(consulta:"select control.fn_registra_actualiza_permiso_censo_2024(null,${permiso.id_persona},'${permiso_detalle.fecha_desde}',${this.form.dias_incapacidad},${this.form.capacitacion_censista},'${permiso.ruta_archivo}',${permiso.id_funcionario},4)"){
                            respuesta
                        }
                    }
                  `
              });
            } catch (error) {
              console.log(error);
            }
            try {
              respuesta =
                respuesta.runQuery.respuesta[0]
                  .fn_registra_actualiza_permiso_censo_2024;
              let resps = respuesta.split("|");
              let correcto = resps[0];
              if (correcto === "1") {
                this.$alert(resps[1]);
                this.redireccionarUrl();
              } else {
                this.$alert(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
            this.loading = false;
          });
        }
        if (this.form.id_tipo_permiso == 90) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permiso_detalle.fecha_desde,
            this.fecha_resultante
          );
          if (verifica_vacacion == true) {
            this.loading_boton = false;
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permiso_detalle.fecha_desde,
            this.fecha_resultante,
            "",
            ""
          );
          if (consulta[0] == true) {
            this.loading_boton = false;
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              console.log(`
                      query{
                        runQuery(consulta:"select control.fn_registra_permiso_baja_medica(${permiso.id_tipo_permiso},'${this.form.tipo_baja}',${permiso.id_persona},'${permiso.fecha_permiso}',${permiso.id_funcionario},'${permiso_detalle.fecha_desde}','${this.fecha_resultante}','${permiso.ruta_archivo}',4)"){
                              respuesta
                          }
                      }
                    `);
              respuesta = await this.$service.graphql({
                query: `
                      query{
                        runQuery(consulta:"select control.fn_registra_permiso_baja_medica(${permiso.id_tipo_permiso},'${this.form.tipo_baja}',${permiso.id_persona},'${permiso.fecha_permiso}',${permiso.id_funcionario},'${permiso_detalle.fecha_desde}','${this.fecha_resultante}','${permiso.ruta_archivo}',4)"){
                              respuesta
                          }
                      }
                    `
              });
            } catch (error) {
              console.log(error);
            }
            try {
              respuesta =
                respuesta.runQuery.respuesta[0].fn_registra_permiso_baja_medica;
              let resps = respuesta.split("|");
              let correcto = resps[0];

              if (correcto === "1") {
                this.$confirm(
                  "Registro exitoso. La cantidad de dias de baja es  " +
                    resps[1],
                  () => {}
                );
                this.redireccionarUrl();
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
            this.loading = false;
          });
        }
        if (this.form.id_tipo_permiso == 6) {
          if (this.validarFechasFinales() == false) {
            return;
          }
          if (
            !this.fecha_desde2 ||
            !this.fecha_hasta2 ||
            !this.form.fecha_fallecimiento ||
            !this.form.hora_fallecimiento
          ) {
            this.$message.info("Fecha no valida");
            return;
          }
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            this.fecha_desde2,
            this.fecha_hasta2
          );
          if (verifica_vacacion == true) {
            this.loading_boton = false;
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            this.fecha_desde2,
            this.fecha_hasta2,
            "",
            ""
          );
          if (consulta[0] == true) {
            this.loading_boton = false;
            return;
          }

          this.$confirm(consulta[1], async () => {
            try {
              if (this.validarFechasFinales() == false) {
                return;
              }
              respuesta = await this.$service.graphql({
                query: `
                      query{
                          runQuery(consulta:"select control.fn_registra_duelo(${permiso.id_persona},'${permiso.fecha_permiso}',${permiso.id_funcionario},'${this.fecha_desde2}','${this.fecha_hasta2}','${this.form.fecha_fallecimiento}','${this.form.hora_fallecimiento}','${permiso.ruta_archivo}',4)"){
                              respuesta
                          }
                      }
                    `
              });
            } catch (error) {
              console.log(error);
            }
            try {
              respuesta = respuesta.runQuery.respuesta[0].fn_registra_duelo;
              let resps = respuesta.split("|");

              let correcto = resps[0];

              if (correcto === "1") {
                this.$confirm("Registro exitoso.", () => {});
                this.redireccionarUrl();
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }

        if (this.form.id_tipo_permiso == 61) {
          if (this.validarFechasFinales() == false) {
            return;
          }
          if (
            !this.fecha_desde2 ||
            !this.fecha_hasta2 ||
            !this.form.fecha_nacimiento ||
            !this.form.hora_nacimiento
          ) {
            this.$message.info("Fecha no valida");
            return;
          }
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            this.fecha_desde2,
            this.fecha_hasta2
          );
          if (verifica_vacacion == true) {
            this.loading_boton = false;
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            this.fecha_desde2,
            this.fecha_hasta2,
            "",
            ""
          );
          if (consulta[0] == true) {
            this.loading_boton = false;
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              respuesta = await this.$service.graphql({
                query: `
                    query{
                      runQuery(consulta:"select control.fn_registra_paternidad(${permiso.id_persona},'${permiso.fecha_permiso}',${permiso.id_funcionario}, '${this.fecha_desde2}','${this.fecha_hasta2}','${this.form.fecha_nacimiento}','${this.form.hora_nacimiento}','${permiso.ruta_archivo}',4)"){
                        respuesta
                      }
                    }
                  `
              });
            } catch (error) {
              console.log(error);
            }
            try {
              respuesta =
                respuesta.runQuery.respuesta[0].fn_registra_paternidad;
              let resps = respuesta.split("|");
              console.log(resps);
              let correcto = resps[0];
              console.log("resp pater:", correcto);
              if (correcto === "1") {
                this.$confirm("Registro exitoso.", () => {});
                this.redireccionarUrl();
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        // p18
        if (this.form.id_tipo_permiso == 18) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_hasta
          );
          if (verifica_vacacion == true) {
            this.loading_boton = false;
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permiso_detalle.fecha_desde,
            permiso_detalle.fecha_hasta,
            "",
            ""
          );
          if (consulta[0] == true) {
            this.loading_boton = false;
            return;
          }
          this.$confirm(consulta[1], async () => {
            let permiso_sin_goce = {
              id_tipo_permiso: parseInt(this.form.id_tipo_permiso),
              causal: this.form.causal_sin_goce
            };
            let consulta = `SELECT control.fn_registra_permiso_sin_haber(${permiso_sin_goce.id_tipo_permiso},'${permiso_sin_goce.causal}',${permiso.id_persona},'${permiso.fecha_permiso}','${permiso_detalle.fecha_desde}','${permiso_detalle.fecha_hasta}',${permiso.id_funcionario},'${permiso.ruta_archivo}')`;
            try {
              respuesta = await this.$service.graphql({
                query: `
                    query{
                      runQuery(consulta:"${consulta}"){
                      respuesta
                      }
                      }
                    `
              });
            } catch (error) {
              console.log(error);
            }
            try {
              respuesta =
                respuesta.runQuery.respuesta[0].fn_registra_permiso_sin_haber;
              let resps = respuesta.split("|");
              let correcto = resps[0];
              if (correcto === "1") {
                this.$confirm("Registro exitoso.", () => {});
                this.redireccionarUrl();
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        if (
          this.form.id_tipo_permiso >= 37 &&
          this.form.id_tipo_permiso <= 43
        ) {
          // Validando si existe otros permisos en el mismo rango de fechas y horas

          let hora_desde, hora_hasta;
          if (valor_tiempo) {
            hora_desde = "";
            hora_hasta = "";
            [hora_desde, hora_hasta] = await this.obtenerHorarioPersona(
              permiso.id_persona,
              valor_tiempo,
              permiso.fecha_permiso
            );
          }
          if (
            (await this.obtenerHorarioPersona(
              permiso.id_persona,
              valor_tiempo,
              permiso.fecha_permiso
            )) != "No"
          ) {
            //consulta si existe una vacacion aprobada en ese rango de fechas
            let verifica_vacacion = await this.verificaVacaciones(
              permiso_detalle.fecha_desde,
              permiso_detalle.fecha_desde
            );
            if (verifica_vacacion == true) {
              this.loading_boton = false;
              return;
            }
            //consulta si existe un permiso aprobado en ese rango de fechas
            let consulta = await this.verificarPermisosRango(
              permiso_detalle.fecha_desde,
              permiso_detalle.fecha_desde,
              hora_desde,
              hora_hasta
            );
            if (consulta[0] == true) {
              this.loading_boton = false;
              return;
            }
            if (!this.form.ruta_archivo || this.form.ruta_archivo == null) {
              return;
            }
            this.$confirm(consulta[1], async () => {
              try {
                console.log(`
                      query{
                        runQuery(consulta:"select control.fn_registra_pap_pros(${permiso.id_tipo_permiso},${permiso.id_persona},'${permiso.fecha_permiso}',${permiso.id_funcionario},'${permiso_detalle.fecha_desde}',${valor_tiempo},'${this.form.ruta_archivo}',4)"){
                          respuesta
                        }
                      }
                    `);
                respuesta = await this.$service.graphql({
                  query: `
                      query{
                        runQuery(consulta:"select control.fn_registra_pap_pros(${permiso.id_tipo_permiso},${permiso.id_persona},'${permiso.fecha_permiso}',${permiso.id_funcionario},'${permiso_detalle.fecha_desde}',${valor_tiempo},'${permiso.ruta_archivo}',4)"){
                          respuesta
                        }
                      }
                    `
                });
              } catch (error) {
                console.log(error);
              }
              try {
                respuesta =
                  respuesta.runQuery.respuesta[0].fn_registra_pap_pros;
                resps = respuesta.split("|");
                correcto = resps[0];

                if (correcto === "1") {
                  this.$confirm("Registro exitoso", () => {});
                  this.redireccionarUrl();
                } else {
                  this.$confirm(resps[1], () => {});
                }
              } catch (error) {
                console.log(error);
              }
            });
          } else {
            this.$confirm("Funcionario sin horario laboral definido", () => {});
          }
        }

        // this.file = "";
        // this.bandera_file = false;
        if (!existe_error_guardar) {
          if (this.getRuta() != this.getPersonaId()) {
            console.log("entra hh");
            this.$router.push("/permisos/usuario");
          }
          if (this.getRuta() == this.getPersonaId()) {
            this.$router.push("/permisos/usuario/" + this.getPersonaId());
          }
        }
        this.loading_boton = false;
      }
    }
  },
  components: {
    CrearPermisoCargoVacacion,
    Compensacion,
    CompensacionTolerancia
  }
};
</script>

<style>
.archivo_vacio {
  background-color: #55aafaea;
  color: #fff;
  cursor: pointer;
  font-size: 1em;
  font-weight: bold;
  margin: 0 auto 0;
  overflow: hidden;
  padding: 0.5em;
  position: relative;
  text-align: center;
  width: 15em;
}
.archivo_cargado {
  background-color: #6ace61;
  color: #fff;
  cursor: pointer;
  font-size: 1em;
  font-weight: bold;
  margin: 0 auto 0;
  overflow: hidden;
  padding: 0.5em;
  position: relative;
  text-align: center;
  width: 15em;
}
.archivo_vacio .input-file {
  cursor: pointer;
  font-size: 10000px;
  margin: 0;
  opacity: 0;
  outline: 0 none;
  padding: 0;
  position: absolute;
  right: -1000px;
  top: -1000px;
}
.archivo_cargado .input-file {
  cursor: pointer;
  font-size: 10000px;
  margin: 0;
  opacity: 0;
  outline: 0 none;
  padding: 0;
  position: absolute;
  right: -1000px;
  top: -1000px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/permiso/PermisoCrearRRHH.vue